(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-desktop-nav"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.msCalmNavigationInstalled)return;
  window.msCalmNavigationInstalled=true;
  const selector='#SiteHeader .site-nav__details';
  const menus=()=>Array.from(document.querySelectorAll(selector));
  const sync=()=>{
    document.documentElement.classList.toggle('ms-navigation-open',matchMedia('(min-width:769px)').matches&&menus().some(menu=>menu.open));
    menus().forEach(menu=>{
    const summary=menu.querySelector(':scope > summary');
    if(summary)summary.setAttribute('aria-expanded',String(menu.open));
    });
  };
  const place=menu=>{
    menu.style.setProperty('--ms-menu-viewport-width',document.documentElement.clientWidth+'px');
    const item=menu.closest('.site-nav__item');
    if(item)menu.style.setProperty('--ms-menu-tab-left',menu.getBoundingClientRect().left+'px');
    const summary=menu.querySelector(':scope > summary');
    if(summary){
      const nav=menu.closest('.site-navigation');
      const bottom=nav?nav.getBoundingClientRect().bottom:summary.getBoundingClientRect().bottom;
      menu.style.setProperty('--ms-menu-top',Math.max(0,bottom)+'px');
      menu.style.setProperty('--ms-menu-offset',(bottom-menu.getBoundingClientRect().top)+'px');
    }
  };
  document.addEventListener('toggle',event=>{
    const menu=event.target;
    if(!menu.matches||!menu.matches(selector))return;
    if(menu.open){
      menus().forEach(other=>{if(other!==menu)other.open=false;});
      place(menu);
    }
    sync();
  },true);
  document.addEventListener('click',event=>{
    if(!event.target.closest(selector))menus().forEach(menu=>{menu.open=false;});
    const closer=event.target.closest('[data-ms-menu-close]');
    if(closer){
      const menu=closer.closest(selector);
      if(menu){menu.open=false;requestAnimationFrame(()=>{menu.querySelector(':scope > summary').focus();sync();});}
      return;
    }
    const summary=event.target.closest('summary');
    if(summary&&summary.parentElement.matches(selector))place(summary.parentElement);
    requestAnimationFrame(sync);
  });
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    const menu=menus().find(item=>item.open);
    if(!menu)return;
    menu.open=false;
    event.preventDefault();
    const summary=menu.querySelector(':scope > summary');
    requestAnimationFrame(()=>summary.focus());
    sync();
  });
  document.addEventListener('focusout',event=>{
    const menu=event.target.closest(selector);
    if(menu&&event.relatedTarget&&!menu.contains(event.relatedTarget)){menu.open=false;sync();}
  });
  window.addEventListener('resize',()=>{menus().filter(menu=>menu.open).forEach(place);sync();});
  document.addEventListener('shopify:section:load',sync);
  sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.product-section-refresh"] && !Shopify.designMode) return;
  try {
    /*============================================================================
    kit-section-refresh
    - Listens for `shopify:product:select` with `{detail: {html}}` section payload
    - Supports only server-rendered markup (no inputs or other dynamic content)
    - Use `data-kit-refresh="<name>"` to mark the regions to replace

    Replaces the variant-dependent regions of a product section with the
    server-rendered markup the variant picker already fetched, so a theme does
    not need client-side code to recompute price, inventory, SKU or button state.
  ==============================================================================*/

  if (!customElements.get('kit-section-refresh')) {
    class KitSectionRefresh extends HTMLElement {
      #selectionId = 0;
      #abortController = null;

      get sectionId() {
        return this.dataset.sectionId;
      }

      get productId() {
        return this.dataset.productId;
      }

      get root() {
        const selector = this.dataset.root;

        if (selector) return this.closest(selector);

        return this.closest('.shopify-section');
      }

      connectedCallback() {
        this.#abortController = new AbortController();

        document.addEventListener('shopify:product:select', event => this.#select(event), {
          signal: this.#abortController.signal,
        });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
      }

      #owns(picker) {
        if (!(picker instanceof HTMLElement) || !picker.matches('kit-variant-picker')) return false;
        if (this.sectionId && picker.dataset.sectionId !== this.sectionId) return false;
        if (this.productId && picker.dataset.productId !== this.productId) return false;

        return true;
      }

      async #select(event) {
        const picker = event.target;
        const root = this.root;

        if (!this.#owns(picker)) return;

        if (!root) {
          console.warn('Section refresh: no root element to refresh within.', this);
          return;
        }

        const selectionId = ++this.#selectionId;
        this.#setBusy(root, true);

        try {
          const result = await event.promise;

          // A newer selection owns the outcome
          if (selectionId !== this.#selectionId) return;

          // Follow the picker to its new product (combined listings)
          this.dataset.productId = picker.dataset.productId;

          const regionMap = this.#fetchedRegions(result);

          if (!regionMap) {
            console.warn('Section refresh: the variant picker resolved without a section document.', result);
            return;
          }

          this.#apply(root, regionMap, picker);
        } catch (error) {
          if (error?.name === 'AbortError') return;
          if (selectionId !== this.#selectionId) return;

          console.error('Section refresh failed:', error);
        } finally {
          if (selectionId === this.#selectionId) this.#setBusy(root, false);
        }
      }

      #fetchedRegions(result) {
        const html = result?.detail?.html;

        if (!html) return null;

        const selector = this.dataset.root;
        const scope = selector ? html.querySelector(selector) : html;

        if (!scope) {
          console.warn(`Section refresh: root "${selector}" not found in the fetched section.`, html);
          return null;
        }

        const byName = new Map();

        scope.querySelectorAll('[data-kit-refresh]').forEach(element => {
          const name = element.dataset.kitRefresh;

          if (!byName.has(name)) byName.set(name, []);

          // Instances (e.g. mobile + desktop copies) accessible by index
          byName.get(name).push(element);
        });

        return byName;
      }

      #apply(root, fetchedRegions, picker) {
        const counts = new Map();

        root.querySelectorAll('[data-kit-refresh]').forEach(target => {
          const name = target.dataset.kitRefresh;
          const instanceIndex = counts.get(name) ?? 0;
          counts.set(name, instanceIndex + 1);

          // Skip picker itself
          if (picker.contains(target) || target.contains(picker)) return;

          const source = fetchedRegions.get(name)?.[instanceIndex];

          if (!source) return;

          // Cloned to allow re-use of the source element
          target.replaceWith(source.cloneNode(true));
        });
      }

      #setBusy(root, busy) {
        if (busy) {
          root.setAttribute('data-kit-refresh-busy', '');
          root.setAttribute('aria-busy', 'true');
        } else {
          root.removeAttribute('data-kit-refresh-busy');
          root.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('kit-section-refresh', KitSectionRefresh);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.product-variant-picker"] && !Shopify.designMode) return;
  try {
    /*============================================================================
    kit-variant-picker
    - For quick shop, fetch the full merchant-configured product page and set
    the correct section id on the picker

    Events:
    - shopify:product-select
    - kit:variant-picker:change (legacy)
    - kit:variant-picker:after-change (legacy)
    - kit:variant-picker:error (legacy)
  ==============================================================================*/

  if (!customElements.get('kit-variant-picker')) {
    class KitVariantPicker extends HTMLElement {
      #abortController = null;
      #standardEventsReady = null;
      // Prevents race conditions between completed requests
      #selectionId = 0;
      #chosenOptions = new Map();

      get sectionId() {
        return this.dataset.sectionId;
      }

      set sectionId(value) {
        this.dataset.sectionId = value;
      }

      connectedCallback() {
        this.#readIdentity();
        this.selectedVariant = JSON.parse(this.querySelector('[data-kit-selected-variant]')?.textContent ?? 'null');
        this.shouldUpdateUrl = 'updateUrl' in this.dataset;
        this.allowUnselected = 'allowUnselected' in this.dataset;
        this.soldOutLabelTemplate = this.querySelector('template[data-sold-out-label-template]');
        this.soldOutLabel = this.soldOutLabelTemplate.content.querySelector('[data-sold-out-label]').textContent;
        this.#resolveAvailability();
        this.#echoChoices();
        this.#standardEventsReady = this.#loadStandardEvents();
        this.addEventListener('change', this.#onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.#onChange);
        this.#abortController?.abort();
      }

      #readIdentity(el = this) {
        this.productId = el.dataset.productId;
        this.productTitle = el.dataset.productTitle;
        this.productHandle = el.dataset.productHandle;
        this.productUrl = el.dataset.productUrl;
        this.variantId = el.dataset.variantId;

        if (el !== this) {
          this.dataset.productId = el.dataset.productId;
          this.dataset.productTitle = el.dataset.productTitle;
          this.dataset.productHandle = el.dataset.productHandle;
          this.dataset.productUrl = el.dataset.productUrl;
          this.dataset.variantId = el.dataset.variantId;
        }
      }

      async #loadStandardEvents() {
        try {
          this.SE = await import('https://cdn.shopify.com/storefront/standard-events.js');
        } catch (error) {
          console.error('Failed to load the Shopify Standard Events module.', error);
        }
      }

      async #onChange(event) {
        const trigger = event.target;

        if (!(trigger instanceof HTMLElement) || !trigger.matches('input[type="radio"], select')) {
          return;
        }

        const selectedOption = trigger.tagName === 'SELECT'
          ? trigger.options[trigger.selectedIndex]
          : trigger.closest('[data-option-value-id]');
        const optionValueId = selectedOption?.dataset.optionValueId;
        const productUrl = selectedOption?.dataset.productUrl;
        const previous = {
          product: this.#product(),
          variantId: this.variantId
        };

        // Remember the selections and check if all options are chosen (for unselected picker)
        let incomplete = false;
        if (this.allowUnselected) {
          this.#getSelectedOptions().forEach(option => this.#chosenOptions.set(option.name, option.id));
          incomplete = this.selectionIncomplete;
        }

        const deferred = await this.#dispatchChange(productUrl, previous, incomplete);
        if (!deferred) return;

        const selectionId = ++this.#selectionId;

        try {
          const html = await this.#refresh(optionValueId, productUrl, selectionId, incomplete);
          const viewEventPayloadEl = html.querySelector('kit-variant-picker [data-view-event-payload]');
          const viewPayload = JSON.parse(viewEventPayloadEl?.textContent?.trim() ?? 'null');
          const viewEventVariant = viewPayload?.product?.selectedVariant ?? null;

          this.#dispatchAfterChange(html, this.selectedVariant, viewEventVariant, deferred, previous);
        } catch (error) {
          deferred.reject(error);

          // Ignore errors triggered by aborted/superseded requests
          if (error.name === 'AbortError') return;
          if (selectionId !== this.#selectionId) return;

          console.error(error);
          this.#dispatchError(error, productUrl, previous);
        }
      }

      async #refresh(changedOptionValueId, productUrl, selectionId, incomplete) {
        const sectionRequestUrl = this.#variantUrl(productUrl);
        sectionRequestUrl.searchParams.set('section_id', this.sectionId);

        this.#abortController?.abort();
        const refreshAbortController = new AbortController();
        this.#abortController = refreshAbortController;

        this.#setLoading();
        try {
          const sectionRequest = await fetch(sectionRequestUrl, { signal: refreshAbortController.signal });

          if (!sectionRequest.ok) {
            throw new Error(`Variant section request failed with ${sectionRequest.status}`);
          }

          const sectionResponse = await sectionRequest.text();
          const sectionHtml = new DOMParser().parseFromString(sectionResponse, 'text/html');
          const newPicker = sectionHtml.querySelector('kit-variant-picker');

          if (!newPicker) {
            throw new Error('<kit-variant-picker> not found');
          }

          // In case a new request begins after the current request can be aborted
          if (selectionId !== this.#selectionId) {
            throw new DOMException('Superseded by a newer selection', 'AbortError');
          }

          this.innerHTML = newPicker.innerHTML;
          this.#readIdentity(newPicker);
          this.selectedVariant = JSON.parse(this.querySelector('[data-kit-selected-variant]')?.textContent ?? 'null');
          this.#reconcileSelections();
          this.#resolveAvailability();
          this.#echoChoices();

          if (incomplete) {
            this.variantId = '';
            this.dataset.variantId = '';
            this.selectedVariant = null;
            this.querySelector('[data-variants]')?.remove();
          }

          this.#restoreFocus(changedOptionValueId);
          this.#updateHistory(this.variantId, productUrl);

          return sectionHtml;
        } finally {
          // Clear loading state if the current request was not superseded
          if (selectionId === this.#selectionId) {
            this.#unsetLoading();
          }
        }
      }

      async #dispatchChange(productUrl, previous, incomplete) {
        const changeEvent = this.#emit('change', {
          picker: this,
          previousVariant: previous.variantId,
          product: previous.product,
          sectionId: this.sectionId,
          selectedOptions: this.#getSelectedOptions().map(({ name, value }) => ({ name, value })),
          selectionIncomplete: incomplete
        }, { cancelable: true });

        if (changeEvent.defaultPrevented) return null;

        // Unselected: still refresh to narrow availability, but no variant reporting
        if (incomplete) return { resolve() { }, reject() { } };

        await this.#standardEventsReady;
        if (!this.SE?.ProductSelectEvent) {
          this.#navigate(productUrl);
          return null;
        }

        const deferred = this.SE.ProductSelectEvent.createPromise();
        this.#standardDispatch({ promise: deferred.promise });
        return deferred;
      }

      #dispatchAfterChange(html, selectedVariant, viewEventVariant, deferred, previous) {
        this.#emit('after-change', {
          html,
          picker: this,
          previousProduct: previous.product,
          previousVariant: previous.variantId,
          product: this.#product(),
          productChanged: previous.product.id !== this.productId,
          sectionId: this.sectionId,
          selectedOptions: this.#getSelectedOptions().map(({ name, value }) => ({ name, value })),
          selectionIncomplete: this.selectionIncomplete,
          variant: selectedVariant
        });

        deferred.resolve({
          detail: { html },
          variant: viewEventVariant
        });
      }

      #dispatchError(error, productUrl, previous) {
        const errorEvent = this.#emit('error', {
          error,
          picker: this,
          previousVariant: previous.variantId,
          product: previous.product,
          sectionId: this.sectionId
        }, { cancelable: true });

        if (!errorEvent.defaultPrevented) {
          this.#navigate(productUrl);
        }
      }

      #standardDispatch({ promise }) {
        const selectedOptions = this.#getSelectedOptions().map(({ name, value }) => {
          return { name, value };
        });

        this.dispatchEvent(new this.SE.ProductSelectEvent({
          selectedOptions,
          product: {
            id: this.productId,
            title: this.productTitle,
            handle: this.productHandle
          },
          promise
        }));
      }

      #product() {
        return {
          id: this.productId,
          title: this.productTitle,
          handle: this.productHandle,
          url: this.productUrl
        };
      }

      #emit(type, detail, { cancelable = false } = {}) {
        const event = new CustomEvent(`kit:variant-picker:${type}`, {
          bubbles: true,
          cancelable,
          detail
        });

        this.dispatchEvent(event);
        return event;
      }

      #navigate(productUrl) {
        const url = this.#variantUrl(productUrl);

        this.#setLoading();
        window.location.assign(url.toString());
      }

      get selectionIncomplete() {
        if (!this.allowUnselected) return false;

        const names = new Set();
        const chosen = new Set();

        this.querySelectorAll('[data-option-name]').forEach(el => {
          const { optionName } = el.dataset;

          names.add(optionName);

          const isChosen = el.tagName === 'SELECT'
            ? el.value !== ''
            : el.querySelector('input[type="radio"]:checked') !== null;

          if (isChosen) chosen.add(optionName);
        });

        return chosen.size < names.size;
      }

      #getSelectedOptions() {
        return [...this.querySelectorAll('input[type="radio"]:checked, select')].map(el => {
          if (el.tagName === 'SELECT') {
            return {
              name: el.dataset.optionName,
              value: el.options[el.selectedIndex]?.value,
              id: el.options[el.selectedIndex]?.dataset.optionValueId
            };
          } else if (el.tagName === 'INPUT') {
            return {
              name: el.closest('[data-option-name]')?.dataset.optionName,
              value: el.value,
              id: el.closest('[data-option-value-id]')?.dataset.optionValueId
            };
          }
        }).filter(option => option.name && option.value && option.id);
      }

      // Since refresh resolves some variant, clear selections that were not chosen
      #reconcileSelections() {
        if (!this.allowUnselected) return;

        [...this.querySelectorAll('[data-option-name]')].forEach(el => {
          const chosenValueId = this.#chosenOptions.get(el.dataset.optionName);

          if (el.tagName === 'SELECT') {
            const match = chosenValueId
              && [...el.options].find(option => option.dataset.optionValueId === chosenValueId);

            if (match) {
              el.value = match.value;
            } else {
              const placeholder = [...el.options].find(option => option.value === '');
              if (placeholder) placeholder.disabled = false;
              el.value = '';
            }
          } else {
            const input = el.querySelector('input[type="radio"]');
            if (input) input.checked = Boolean(chosenValueId) && el.dataset.optionValueId === chosenValueId;
          }
        });
      }

      // Proper availability resolution for incomplete selections (Shopify defaults to a fallback variant's values)
      #resolveAvailability() {
        if (!this.selectionIncomplete && this.selectedVariant) return;

        const availableOptions = JSON.parse(this.querySelector('[data-kit-available-options]')?.textContent ?? 'null');

        // High-variant products and combined listings
        if (!availableOptions) {
          this.#resetUnresolvedAvailability();
          return;
        }

        // With nothing chosen, the server already rated every value against these variants
        const anyChosen = [...this.querySelectorAll('fieldset')].some(fieldset => this.#chosenValue(fieldset) !== null);
        if (anyChosen) this.#applyTrueAvailability(availableOptions);
      }

      #applyTrueAvailability(availableOptions) {
        const chosen = [];

        this.querySelectorAll('fieldset').forEach((fieldset, index) => {
          const matchesEarlierChoices = options => chosen.every((chosenValue, i) => {
            const isUnchosen = chosenValue === null;
            const isMatchingChoice = options[i] === chosenValue;

            return isUnchosen || isMatchingChoice;
          });

          // Mark available if the combination with earlier choices belongs to an available variant
          this.#markAvailability(fieldset, value => {
            return availableOptions.some(options => {
              const isMatchingValue = options[index] === value;

              return isMatchingValue && matchesEarlierChoices(options);
            });
          });

          chosen.push(this.#chosenValue(fieldset));
        });
      }

      // Resets availability for unresolved options
      #resetUnresolvedAvailability() {
        let earlierChosen = true;

        this.querySelectorAll('fieldset').forEach(fieldset => {
          if (!earlierChosen) this.#markAvailability(fieldset, () => true);

          earlierChosen = earlierChosen && this.#chosenValue(fieldset) !== null;
        });
      }

      #chosenValue(fieldset) {
        const select = fieldset.querySelector('select');

        return select
          ? select.value || null
          : fieldset.querySelector('input[type="radio"]:checked')?.value ?? null;
      }

      #markAvailability(fieldset, isAvailable) {

        fieldset.querySelectorAll('option:not([value=""])').forEach(option => {
          const available = isAvailable(option.value);

          option.textContent = available ? option.value : `${option.value}${this.soldOutLabel}`;
        });

        fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
          const available = isAvailable(input.value);
          const radio = input.closest('[data-option-value-id]');

          radio?.querySelector('.kit-button')?.classList.toggle('kit-button--disabled', !available);
          radio?.querySelector('.kit-swatch')?.classList.toggle('kit-swatch--disabled', !available);

          // Keeps the screen-reader sold-out label in step with the visual marking
          const label = radio?.querySelector('[data-sold-out-label]');
          if (available) {
            label?.remove();
          } else if (!label) {
            radio?.append(this.soldOutLabelTemplate.content.cloneNode(true));
          }
        });
      }

      #echoChoices() {
        this.querySelectorAll('input[type="radio"]:checked').forEach(input => {
          const selection = input.closest('fieldset')?.querySelector('.kit-fieldset__legend-selection');

          if (selection) selection.textContent = input.value;
        });
      }

      #variantUrl(productUrl) {
        const url = new URL(productUrl || this.productUrl, window.location.origin);
        const optionValues = this.#getSelectedOptions()
          .map(option => option.id)
          .join(',');

        url.searchParams.set('option_values', optionValues);
        return url;
      }

      #updateHistory(variantId, productUrl) {
        if (!this.shouldUpdateUrl || window.Shopify?.designMode) return;

        const url = new URL(window.location.href);

        if (productUrl) {
          url.pathname = new URL(productUrl, window.location.origin).pathname;
        }

        if (variantId) {
          url.searchParams.set('variant', variantId);
        } else {
          url.searchParams.delete('variant');
        }

        window.history.replaceState({}, '', url.toString());
      }

      #restoreFocus(optionValueId) {
        const option = this.querySelector(`[data-option-value-id="${optionValueId}"]`);

        if (!option) return;
        if (option.tagName === 'OPTION' && !matchMedia('(pointer: coarse)').matches) {
          option.closest('select')?.focus();
        } else {
          (option.querySelector('input') || option).focus();
        }
      }

      #setLoading() {
        this.classList.add('kit-picker--loading');
      }

      #unsetLoading() {
        this.classList.remove('kit-picker--loading');
      }
    }

    customElements.define('kit-variant-picker', KitVariantPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.tooltip"] && !Shopify.designMode) return;
  try {
    const FLIPS = { top: 'bottom', bottom: 'top', start: 'end', end: 'start' };
  const VIEWPORT_MARGIN = 4;
  const MIN_ARROW_INSET = 12;
  const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

  // After one tooltip is shown, neighbouring triggers open instantly for a short period.
  const WARM_WINDOW = 300;
  let warmUntil = 0;

  // Only one tooltip on the page is open at a time
  let openTooltip = null;

  class KitTooltip extends HTMLElement {
    #abortController = null;
    #openAbortController = null;
    #showTimeout = null;
    #placement = String();
    #delay = Number();
    #showOnFocus = Boolean();
    #isRTL = Boolean();
    #trigger = null;
    #bubble = null;

    connectedCallback() {
      this.#placement = this.getAttribute('placement') || 'top';
      this.#delay = Number(this.getAttribute('delay')) || 0;
      this.#showOnFocus = this.getAttribute('show-on-focus') !== 'false';
      this.#trigger = this.querySelector('.kit-tooltip__trigger');
      this.#bubble = this.querySelector('.kit-tooltip__bubble');
      this.#isRTL = getComputedStyle(this).direction === 'rtl';

      if (this.#isRTL && !this.matches(':dir(rtl)')) this.setAttribute('dir', 'rtl');

      if (!this.#trigger || !this.#bubble) return;

      this.#wireDescription();

      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#trigger.addEventListener('mouseenter', () => this.#scheduleShow(), { signal });
      this.#trigger.addEventListener('mouseleave', () => this.#hide(), { signal });
      this.#trigger.addEventListener('focusout', () => this.#hide(), { signal });

      if (this.#showOnFocus) {
        this.#trigger.addEventListener(
          'focusin',
          (event) => {
            if (event.target instanceof Element && event.target.matches(':focus-visible')) this.#show();
          },
          { signal }
        );
      }

      // Hide until measured, or it flashes at the previous position
      this.#bubble.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') this.#bubble.style.visibility = 'hidden';
        },
        { signal }
      );

      this.#bubble.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.#bubble.style.visibility = '';
            this.#trackWhileOpen();
          } else {
            this.#openAbortController?.abort();
            this.#openAbortController = null;
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      if (openTooltip === this) openTooltip = null;
      this.#abortController?.abort();
      this.#openAbortController?.abort();
      clearTimeout(this.#showTimeout);
    }

    #trackWhileOpen() {
      this.#openAbortController?.abort();
      this.#openAbortController = new AbortController();

      window.addEventListener('resize', () => this.#position(), {
        passive: true,
        signal: this.#openAbortController.signal,
      });

      document.addEventListener('keydown', (event) => event.key === 'Escape' && this.#hide(), {
        signal: this.#openAbortController.signal,
      });
    }

    // The focusable element is usually nested (a radio inside a label)
    #wireDescription() {
      if (this.#bubble.getAttribute('aria-hidden') === 'true') return;

      const describable = this.#trigger.querySelector(
        'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (describable && !describable.hasAttribute('aria-describedby')) {
        describable.setAttribute('aria-describedby', this.#bubble.id);
      }
    }

    #scheduleShow() {
      // Tapping fires a synthetic mouseenter; only real hover should open
      if (!FINE_POINTER.matches) return;

      clearTimeout(this.#showTimeout);

      if (Date.now() < warmUntil) {
        this.#show();
        return;
      }

      this.#showTimeout = setTimeout(() => this.#show(), this.#delay);
    }

    #show() {
      clearTimeout(this.#showTimeout);
      if (this.#bubble.matches(':popover-open')) return;

      openTooltip?.#hide();
      openTooltip = this;

      this.setAttribute('placement', this.#placement);
      this.#bubble.showPopover();
    }

    #hide() {
      clearTimeout(this.#showTimeout);
      if (openTooltip === this) openTooltip = null;
      if (!this.#bubble.matches(':popover-open')) return;

      this.#bubble.hidePopover();
      this.setAttribute('placement', this.#placement);
      warmUntil = Date.now() + WARM_WINDOW;
    }

    #position() {
      const anchor = this.#trigger.getBoundingClientRect();
      const width = this.#bubble.offsetWidth;
      const height = this.#bubble.offsetHeight;
      const offset = parseFloat(getComputedStyle(this.#bubble).getPropertyValue('--kit-tooltip-offset')) || 0;
      const vw = document.documentElement.clientWidth;
      const vh = document.documentElement.clientHeight;

      let placement = this.#placement;
      let box = this.#boxFor(placement, anchor, width, height, offset);

      if (!this.#fits(box, width, height, vw, vh)) {
        const flipped = this.#boxFor(FLIPS[placement], anchor, width, height, offset);

        if (this.#fits(flipped, width, height, vw, vh)) {
          placement = FLIPS[placement];
          box = flipped;
        }
      }

      this.setAttribute('placement', placement);

      const left = clamp(box.left, VIEWPORT_MARGIN, Math.max(VIEWPORT_MARGIN, vw - VIEWPORT_MARGIN - width));
      const top = clamp(box.top, VIEWPORT_MARGIN, Math.max(VIEWPORT_MARGIN, vh - VIEWPORT_MARGIN - height));

      this.#bubble.style.left = `${Math.round(left + window.scrollX)}px`;
      this.#bubble.style.top = `${Math.round(top + window.scrollY)}px`;

      this.#positionArrow(placement, anchor, { height, left, top, width });
    }

    // Keep the arrow on the trigger after clamping
    #positionArrow(placement, anchor, box) {
      const isVertical = placement === 'top' || placement === 'bottom';
      const anchorCenter = isVertical ? anchor.left + anchor.width / 2 : anchor.top + anchor.height / 2;
      const bubbleCenter = isVertical ? box.left + box.width / 2 : box.top + box.height / 2;
      const limit = Math.max(0, (isVertical ? box.width : box.height) / 2 - MIN_ARROW_INSET);

      this.#bubble.style.setProperty('--arrow-offset', `${clamp(anchorCenter - bubbleCenter, -limit, limit)}px`);
    }

    #boxFor(placement, anchor, width, height, offset) {
      // start/end are logical, so they swap sides in RTL
      const beforeAnchor = anchor.left - offset - width;
      const afterAnchor = anchor.right + offset;
      const centeredTop = anchor.top + anchor.height / 2 - height / 2;

      switch (placement) {
        case 'bottom':
          return { left: anchor.left + anchor.width / 2 - width / 2, top: anchor.bottom + offset };
        case 'start':
          return { left: this.#isRTL ? afterAnchor : beforeAnchor, top: centeredTop };
        case 'end':
          return { left: this.#isRTL ? beforeAnchor : afterAnchor, top: centeredTop };
        default:
          return { left: anchor.left + anchor.width / 2 - width / 2, top: anchor.top - offset - height };
      }
    }

    #fits(box, width, height, vw, vh) {
      if (this.#placement === 'top' || this.#placement === 'bottom') {
        return box.top >= VIEWPORT_MARGIN && box.top + height <= vh - VIEWPORT_MARGIN;
      }

      return box.left >= VIEWPORT_MARGIN && box.left + width <= vw - VIEWPORT_MARGIN;
    }
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  customElements.define('kit-tooltip', KitTooltip);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-al-selected-performance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-al-selected-performance')) {
  customElements.define('ms-al-selected-performance', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const normalize = value => String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
      const covers = new Map(Object.entries(JSON.parse(this.querySelector('script').textContent)).map(([name, brand]) => [normalize(name), brand]));
      const update = () => {
        this.frame = null;
        if (!this.root || !this.root.isConnected) { bind(); return; }
        this.observer.disconnect();
        this.root.querySelectorAll('.selector-wrapper').forEach(group => {
          const fabric = group.querySelector('input[type="radio"][name^="properties[Fabric Grade"]');
          if (!fabric) return;
          const label = group.querySelector('.bcpo-label');
          if (!label) return;

          let verifiedCount = 0;
          group.querySelectorAll('input[type="radio"]').forEach(input => {
            const swatchLabel = input.parentElement.querySelector('.bcpo-front-image-label');
            if (!swatchLabel) return;
            const performanceBrand = covers.get(normalize(input.value));
            let marker = swatchLabel.querySelector('.ms-al-performance-marker');
            let description = swatchLabel.querySelector('.ms-al-performance-description');
            if (!performanceBrand) {
              if (marker) marker.remove();
              if (description) description.remove();
              return;
            }
            verifiedCount++;
            if (!marker) {
              marker = document.createElement('span');
              marker.className = 'ms-al-performance-marker';
              marker.textContent = 'P';
              marker.setAttribute('aria-hidden', 'true');
              swatchLabel.appendChild(marker);
            }
            if (!description) {
              description = document.createElement('span');
              description.className = 'ms-al-performance-description visually-hidden';
              swatchLabel.appendChild(description);
            }
            const descriptionText = input.value + ' — ' + this.dataset.label + (performanceBrand === 'Performance' ? '' : ' · ' + performanceBrand);
            if (description.textContent !== descriptionText) description.textContent = descriptionText;
          });
          let legend = group.querySelector('.ms-al-performance-legend');
          if (!legend && verifiedCount) {
            legend = document.createElement('p');
            legend.className = 'ms-al-performance-legend';
            legend.textContent = 'P = ' + this.dataset.legend;
            legend.title = this.dataset.verified;
            label.appendChild(legend);
          }
          if (legend) legend.hidden = !verifiedCount;
          let badge = label.querySelector('.ms-al-selected-performance');
          const selected = group.querySelector('input[type="radio"]:checked:not(:disabled)');
          const visible = group.getClientRects().length > 0 && getComputedStyle(group).visibility !== 'hidden';
          const brand = visible && selected ? covers.get(normalize(selected.value)) : '';
          if (!badge && !brand) return;
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'ms-al-selected-performance';
            badge.setAttribute('role', 'status');
            badge.setAttribute('aria-live', 'polite');
            badge.title = this.dataset.verified;
            label.insertBefore(badge, label.querySelector('.ms-al-performance-legend'));
          }
          const text = brand ? this.dataset.label + (brand === 'Performance' ? '' : ' · ' + brand) : '';
          if (badge.textContent !== text) badge.textContent = text;
          badge.hidden = !brand;
        });
        this.observe();
      };
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
      this.observer = new MutationObserver(this.schedule);
      this.observe = () => this.observer.observe(this.root, {childList:true, subtree:true, attributes:true, attributeFilter:['class', 'style', 'hidden', 'disabled']});
      const bind = () => {
        const root = document.querySelector('#bcpo');
        if (root !== this.root) {
          if (this.root) this.root.removeEventListener('change', this.schedule);
          this.observer.disconnect();
          this.root = root;
          if (root) { root.addEventListener('change', this.schedule); this.observe(); }
        }
        if (root) this.schedule();
      };
      this.discovery = new MutationObserver(() => { if (!this.root || !this.root.isConnected) bind(); });
      this.discovery.observe(document.body, {childList:true, subtree:true});
      bind();
    }
    disconnectedCallback() {
      if (this.discovery) this.discovery.disconnect();
      if (this.observer) this.observer.disconnect();
      if (this.root) this.root.removeEventListener('change', this.schedule);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.started = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-collection-local-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-collection-local-search')) {
  customElements.define('ms-collection-local-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const self = this;
      const input = this.querySelector('[data-local-query]');
      const sale = this.querySelector('[data-local-sale]');
      const performance = this.querySelector('[data-local-performance]');
      const performanceData = this.querySelector('[data-performance-covers]');
      const coverKey = title => String(title || '').replace(/^grade\s+[a-z0-9]+\s*:\s*/i, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
      const performanceCovers = new Map(Object.entries(performanceData ? JSON.parse(performanceData.textContent) : {}).map(([name, brand]) => [coverKey(name), brand]));
      const performanceBrand = title => performanceCovers.get(coverKey(title)) || '';
      const decorate = scope => {
        if (!performance) return;
        scope.querySelectorAll('.grid-product[data-product-id]').forEach(card => {
          const title = card.querySelector('.grid-product__title');
          const brand = performanceBrand(title?.textContent);
          if (!title || !brand || card.querySelector('.ms-al-performance-badge')) return;
          const badge = document.createElement('span');
          badge.className = 'ms-al-performance-badge';
          badge.textContent = self.dataset.performanceLabel + (brand === 'Performance' ? '' : ' · ' + brand);
          badge.title = self.dataset.performanceVerified;
          title.after(badge);
        });
        const nav = document.querySelector('.ms-al-swatch-page .hp-materials');
        if (nav && !nav.querySelector('.ms-al-performance-guide')) {
          const link = document.createElement('a');
          link.className = 'ms-al-performance-guide';
          link.href = nav.querySelector('a').href + '?ms_performance=1#CollectionAjaxContent';
          link.textContent = self.dataset.performanceGuide;
          nav.querySelectorAll('a')[1].after(link);
        }
        const link = nav?.querySelector('.ms-al-performance-guide');
        if (link) link.setAttribute('aria-current', performance.checked ? 'true' : 'false');
      };
      const clear = this.querySelector('[data-local-clear]');
      const status = this.querySelector('[data-local-status]');
      const more = this.querySelector('[data-local-more]');
      const shown = this.querySelector('[data-local-shown]');
      const load = this.querySelector('[data-local-load]');
      let state, version = 0, limit = 35, matches = [];
      const storageKey = 'ms-collection-local-search:' + location.pathname;
      const outdoorSearch = this.dataset.outdoorSearch === 'true';
      const requested = new URL(location.href);
      const requestedQuery = requested.searchParams.get('ms_query');
      const requestedSale = requested.searchParams.get('ms_sale');
      if (performance) performance.checked = requested.searchParams.get('ms_performance') === '1';
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        input.value = requestedQuery !== null ? requestedQuery : outdoorSearch ? '' : saved.query || '';
        sale.checked = requestedSale !== null ? requestedSale === '1' : !outdoorSearch && saved.sale === true;
      } catch (error) {}
      const remember = () => {
        if (performance) {
          const url = new URL(location.href);
          if (performance.checked) url.searchParams.set('ms_performance', '1');
          else url.searchParams.delete('ms_performance');
          history.replaceState(history.state, '', url);
          document.querySelectorAll('.ms-al-swatch-page .hp-options a').forEach(link => {
            const target = new URL(link.href);
            if (performance.checked) target.searchParams.set('ms_performance', '1');
            else target.searchParams.delete('ms_performance');
            if (link.href !== target.href) link.href = target.href;
          });
          decorate(document);
        }
        if (outdoorSearch) {
          const url = new URL(location.href);
          if (input.value.trim()) url.searchParams.set('ms_query', input.value.trim());
          else url.searchParams.delete('ms_query');
          if (sale.checked) url.searchParams.set('ms_sale', '1');
          else url.searchParams.delete('ms_sale');
          history.replaceState(history.state, '', url);
          return;
        }
        try { sessionStorage.setItem(storageKey, JSON.stringify({query:input.value, sale:sale.checked})); } catch (error) {}
      };
      const active = () => input.value.trim() || sale.checked || performance?.checked;
      const normalize = value => {
        const text = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        return outdoorSearch ? text.replace(/\b(?:eco|echo)[\s-]*smart\b/g, 'ecosmart').replace(/\bharbor\b/g, 'harbour').replace(/[^a-z0-9]+/g, ' ').trim() : text;
      };
      const cards = scope => [...scope.querySelectorAll('.grid-product[data-product-id]')];
      const restore = () => {
        if (!state?.grid.isConnected) return;
        state.grid.replaceChildren(...state.original);
        state.container.classList.remove('ds-local-active');
        state.grid.removeAttribute('aria-busy');
        if (state.count) state.count.textContent = state.countText;
        more.hidden = true;
      };
      const workers = async (items, run) => {
        const queue = [...items];
        await Promise.all(Array.from({length: Math.min(3, queue.length)}, async () => {
          while (queue.length) await run(queue.shift());
        }));
      };
      const collect = async current => {
        if (current.all) return current.all;
        if (current.pending) return current.pending;
        current.pending = (async () => {
          const get = async page => {
            const url = new URL(current.url);
            url.hash = '';
            ['section_id', 'sections', 'ms_query', 'ms_sale', 'ms_performance'].forEach(key => url.searchParams.delete(key));
            url.searchParams.set('view', 'ms-search-index');
            url.searchParams.set('page', page);
            const response = await fetch(url, {signal: AbortSignal.timeout(25000)});
            if (!response.ok) throw new Error('Collection index unavailable');
            const data = JSON.parse(await response.text());
            if (!Array.isArray(data.products) || data.page !== page || data.total > 25000) throw new Error('Invalid collection index');
            return data;
          };
          const first = await get(1);
          const pages = new Map([[1, first.products]]);
          await workers(Array.from({length: Math.max(0, first.pages - 1)}, (_, i) => i + 2), async page => {
            const data = await get(page);
            if (data.total !== first.total) throw new Error('Collection changed during search');
            pages.set(page, data.products);
          });
          const all = [...pages.entries()].sort((a,b) => a[0]-b[0]).flatMap(([,items]) => items);
          if (all.length !== first.total || new Set(all.map(item => item.id)).size !== all.length) throw new Error('Incomplete collection index');
          current.all = all.map((item, index) => ({...item, page: Math.floor(index / current.pageSize) + 1}));
          return current.all;
        })().catch(error => {current.pending = null;throw error;});
        return current.pending;
      };
      const render = async () => {
        const current = state;
        const token = version;
        if (!current?.grid.isConnected) return;
        const visible = matches.slice(0, limit);
        load.disabled = true;
        current.grid.setAttribute('aria-busy', 'true');
        try {
          const pages = [...new Set(visible.filter(item => !current.cardCache.has(item.id)).map(item => item.page))];
          await workers(pages, async page => {
            const url = new URL(current.url);
            url.hash = '';
            url.searchParams.delete('ms_query');
            url.searchParams.delete('ms_sale');
            url.searchParams.delete('ms_performance');
            url.searchParams.set('page', page);
            url.searchParams.set('section_id', current.sectionId);
            const response = await fetch(url, {signal: AbortSignal.timeout(25000)});
            if (!response.ok) throw new Error('Collection cards unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            cards(doc.querySelector('#CollectionAjaxContent') || doc).forEach(card => {
              current.cardCache.set(card.dataset.productId, document.importNode(card, true));
            });
          });
          if (token !== version || current !== state || !active()) return;
          const selected = visible.map(item => current.cardCache.get(item.id));
          if (selected.some(card => !card)) throw new Error('Collection changed during search');
          current.container.classList.add('ds-local-active');
          current.grid.replaceChildren(...selected);
          decorate(current.grid);
          current.grid.querySelectorAll('[data-aos]').forEach(element => element.classList.add('aos-init', 'aos-animate'));
          current.grid.removeAttribute('aria-busy');
          status.textContent = self.dataset.results.replace('[count]', matches.length);
          if (current.count) current.count.textContent = status.textContent;
          shown.textContent = self.dataset.shown.replace('[visible]', visible.length).replace('[total]', matches.length);
          more.hidden = matches.length === 0;
          load.hidden = limit >= matches.length;
        } catch (error) {
          if (token !== version || current !== state) return;
          restore();
          status.textContent = self.dataset.error;
        } finally {
          if (token === version) load.disabled = false;
        }
      };
      const apply = async () => {
        remember();
        const token = ++version;
        limit = 35;
        clear.hidden = !active();
        if (!state || !active()) {
          restore();
          status.textContent = '';
          return;
        }
        const current = state;
        status.textContent = self.dataset.loading;
        current.grid.setAttribute('aria-busy', 'true');
        try {
          const all = await collect(current);
          if (token !== version || current !== state || !active()) return;
          const terms = normalize(input.value.trim()).split(/\s+/).filter(Boolean).map(term => term.length > 3 && term.endsWith('s') ? term.slice(0,-1) : term);
          matches = all.filter(item => {
            const text = normalize((outdoorSearch ? [item.title, item.vendor] : [item.title, item.vendor, item.handle, performanceBrand(item.title) ? 'performance ' + performanceBrand(item.title) : '']).join(' '));
            const words = text.split(/\s+/);
            return terms.every(term => outdoorSearch ? words.some(word => word.startsWith(term)) : text.includes(term)) && (!sale.checked || item.sale) && (!performance?.checked || !!performanceBrand(item.title));
          });
          await render();
        } catch (error) {
          if (token !== version || current !== state) return;
          restore();
          status.textContent = self.dataset.error;
        }
      };
      const bind = () => {
        const container = document.querySelector('#CollectionAjaxContent');
        const grid = container?.querySelector('.grid--uniform');
        if (grid) decorate(container);
        if (!grid || grid === state?.grid) return;
        version++;
        const pagination = container.querySelector('.pagination');
        const url = new URL(location.href);
        const page = Number(url.searchParams.get('page') || 1);
        const pageNumbers = [...(pagination?.querySelectorAll('a[href]') || [])].map(a => Number(new URL(a.href).searchParams.get('page') || 1));
        const count = container.querySelector('.collection-filter__item--count');
        state = {container, grid, original:[...grid.childNodes], count, countText:count?.textContent || '', page, pages:Math.max(page, ...pageNumbers), url:url.href, sectionId:container.closest('[data-section-id]').dataset.sectionId};
        state.pageSize = Number(container.querySelector('[data-ms-page-size]')?.dataset.msPageSize || cards(grid).length);
        state.cardCache = new Map(cards(grid).map(card => [card.dataset.productId, card]));
        container.querySelector('.grid__item--content').prepend(self);
        grid.after(more);
        self.hidden = false;
        if (active()) apply();
      };
      let typingTimer;
      input.addEventListener('input', () => {version++;clearTimeout(typingTimer);typingTimer = setTimeout(apply, 180);});
      input.addEventListener('search', () => {clearTimeout(typingTimer);apply();});
      sale.addEventListener('change', apply);
      performance?.addEventListener('change', apply);
      clear.addEventListener('click', () => {clearTimeout(typingTimer);input.value = '';sale.checked = false;if (performance) performance.checked = false;const url = new URL(location.href);url.searchParams.delete('ms_query');url.searchParams.delete('ms_sale');history.replaceState(history.state, '', url);apply();});
      load.addEventListener('click', () => {limit += 35;render();});
      const start = () => {
        bind();
        new MutationObserver(bind).observe(document.querySelector('#MainContent'), {childList:true,subtree:true});
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
      else start();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-collection-polish"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href^="#"]');
    if (!link || !link.closest('section.ms-collection-polished')) return;
    const id = link.getAttribute('href').slice(1);
    const target = document.getElementById(id);
    if (target?.matches('[data-ms-polished-directory]') && !link.hasAttribute('data-side-jump-chip') && !link.hasAttribute('data-bdi-jump-chip') && !link.hasAttribute('data-copeland-jump-chip') && !link.hasAttribute('data-al-jump-chip') && !link.hasAttribute('data-sect-jump-chip')) {
      const searchInput = target.querySelector('.ms-directory-finder input[type="search"]');
      if (searchInput) {
        event.preventDefault();
        event.stopPropagation();
        if (location.hash !== '#' + id) history.pushState(null, '', '#' + id);
        target.scrollIntoView({behavior:'instant',block:'start'});
        searchInput.focus({preventScroll:true});
        return;
      }
    }
    const details = target?.matches('details') ? target : target?.closest('details');
    if (!details?.classList.contains('ms-collection-inspiration')) return;
    event.preventDefault();
    event.stopPropagation();
    details.open = true;
    if (location.hash !== '#' + id) history.pushState(null, '', '#' + id);
    requestAnimationFrame(() => {
      target.scrollIntoView({behavior:'instant',block:'start'});
      details.querySelector('summary')?.focus({preventScroll:true});
    });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-collection-standard"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    if (!document.querySelector('.ms-collection-standard')) return;
    if (window.msCollectionStandardStarted) return;
    window.msCollectionStandardStarted = true;
    const viewName = new URL(location.href).searchParams.get('view');
    const desktop = matchMedia('(min-width:769px)');
    let filtersOpen = false;
    const expandedGroups = new Set();
    const seenPanels = new WeakSet();
    let priceViewport = null;
    const rememberGroups = () => {
      expandedGroups.clear();
      document.querySelectorAll('#FilterDrawer .collapsible-trigger[aria-expanded="true"]').forEach(button => {
        expandedGroups.add(button.getAttribute('aria-controls'));
      });
    };
    const restoreGroups = panel => {
      panel.querySelectorAll('.collapsible-trigger').forEach(button => {
        const id = button.getAttribute('aria-controls');
        if (!expandedGroups.has(id)) return;
        const content = document.getElementById(id);
        button.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        if (content) {
          content.classList.remove('hide');
          content.classList.add('is-open');
          content.style.height = 'auto';
        }
      });
    };
    const rememberPriceInteraction = event => {
      const range = event.target.closest('#FilterDrawer .price-range');
      if (!range) return;
      rememberGroups();
      if (desktop.matches) {
        const handle = event.target.closest('[role="slider"]');
        priceViewport = {top:range.getBoundingClientRect().top, handle:handle?.dataset.handle, keyboard:event.type === 'keydown'};
      }
    };
    document.addEventListener('pointerdown', rememberPriceInteraction, true);
    document.addEventListener('keydown', rememberPriceInteraction, true);
    document.addEventListener('click', event => {
      if (event.target.closest('#FilterDrawer .collapsible-trigger')) queueMicrotask(rememberGroups);
    }, true);
    document.addEventListener('wheel', () => {priceViewport = null;}, {passive:true});
    document.addEventListener('collection:reloaded', () => {
      const panel = document.querySelector('#FilterDrawer');
      if (panel) restoreGroups(panel);
      if (!priceViewport || !desktop.matches) return;
      const previous = priceViewport;
      priceViewport = null;
      requestAnimationFrame(() => {
        const range = document.querySelector('#FilterDrawer .price-range');
        if (!range) return;
        window.scrollBy({top:range.getBoundingClientRect().top - previous.top, behavior:'instant'});
        if (previous.keyboard) range.querySelector('[data-handle="' + previous.handle + '"]')?.focus({preventScroll:true});
      });
    });
    const syncPanel = () => {
      const toolbar = document.querySelector('#CollectionAjaxContent .collection-filter');
      const panel = document.querySelector('#FilterDrawer');
      const sidebar = document.querySelector('#CollectionSidebar');
      const button = toolbar?.querySelector('.js-drawer-open-collection-filters');
      if (!toolbar || !panel || !sidebar || !button) return;
      const browse = document.querySelector('template[data-ms-standard-browse]');
      if (browse && !panel.querySelector('.ms-standard-browse')) {
        panel.querySelector('.drawer__scrollable').append(browse.content.cloneNode(true));
      }
      button.parentElement.hidden = !browse && !panel.querySelector('.collapsible-trigger');

      if (!seenPanels.has(panel)) {
        seenPanels.add(panel);
        restoreGroups(panel);
      }
      if (desktop.matches) {
        if (panel.previousElementSibling !== toolbar) toolbar.after(panel);
        panel.classList.add('ms-inline-filters');
        panel.dataset.inlineOpen = String(filtersOpen);
        panel.setAttribute('role', 'region');
        panel.removeAttribute('aria-modal');
        panel.setAttribute('aria-label', button.textContent.trim());
        button.setAttribute('aria-expanded', String(filtersOpen));
      } else {
        if (panel.parentElement !== sidebar) sidebar.append(panel);
        panel.classList.remove('ms-inline-filters');
        delete panel.dataset.inlineOpen;
        panel.removeAttribute('role');
        panel.removeAttribute('aria-label');
      }
    };
    document.addEventListener('click', event => {
      if (!desktop.matches) return;
      const button = event.target.closest('#CollectionAjaxContent .js-drawer-open-collection-filters');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      filtersOpen = !filtersOpen;
      syncPanel();
    }, true);
    document.addEventListener('keydown', event => {
      if (!desktop.matches || !filtersOpen || event.key !== 'Escape') return;
      const button = document.querySelector('#CollectionAjaxContent .js-drawer-open-collection-filters');
      filtersOpen = false;
      syncPanel();
      button?.focus({preventScroll:true});
    });
    desktop.addEventListener('change', () => {
      if (desktop.matches) document.querySelector('#FilterDrawer .js-drawer-close')?.click();
      filtersOpen = false;
      syncPanel();
    });
    const arrange = () => {
      const productGrid = document.querySelector('#CollectionAjaxContent .grid--uniform');
      if (productGrid) productGrid.classList.toggle('ms-standard-css-grid', getComputedStyle(productGrid).display === 'grid');
      document.querySelectorAll('#CollectionAjaxContent .filter-form').forEach(form => {
        const params = new URL(location.href).searchParams;
        ['sort_by', 'q'].forEach(name => {
          if (!params.has(name) || form.querySelector('input[name="' + name + '"]')) return;
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = name;
          field.value = params.get(name);
          form.append(field);
        });
        if (!viewName) return;
        let view = form.querySelector('input[name="view"]');
        if (view) {
          view.value = viewName;
          return;
        }
        view = document.createElement('input');
        view.type = 'hidden';
        view.name = 'view';
        view.value = viewName;
        form.append(view);
      });
      document.querySelectorAll('#CollectionAjaxContent .tag-list--active-tags a,#CollectionAjaxContent .pagination a').forEach(link => {
        const url = new URL(link.getAttribute('href') || '', location.href);
        if (!viewName || url.searchParams.get('view') === viewName) return;
        url.searchParams.set('view', viewName);
        link.href = url.href;
      });
      const toolbar = document.querySelector('#CollectionAjaxContent .collection-filter');
      const search = document.querySelector('ms-collection-local-search,ms-dining-local-search');
      if (toolbar && search && !search.hidden && search.parentElement !== toolbar) toolbar.append(search);
      syncPanel();
    };
    arrange();
    new MutationObserver(arrange).observe(document.querySelector('#MainContent'), {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-dining-local-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-dining-local-search')) {
  customElements.define('ms-dining-local-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const self = this;
      const input = this.querySelector('[data-local-query]');
      const sale = this.querySelector('[data-local-sale]');
      const clear = this.querySelector('[data-local-clear]');
      const status = this.querySelector('[data-local-status]');
      const more = this.querySelector('[data-local-more]');
      const shown = this.querySelector('[data-local-shown]');
      const load = this.querySelector('[data-local-load]');
      let state, version = 0, limit = 35, matches = [];
      const storageKey = 'ms-dining-local-search:' + location.pathname;
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        input.value = saved.query || '';
        sale.checked = saved.sale === true;
      } catch (error) {}
      const remember = () => {
        try { sessionStorage.setItem(storageKey, JSON.stringify({query:input.value, sale:sale.checked})); } catch (error) {}
      };
      const active = () => input.value.trim() || sale.checked;
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const cards = scope => [...scope.querySelectorAll('.grid-product[data-product-id]')];
      const restore = () => {
        if (!state?.grid.isConnected) return;
        state.grid.replaceChildren(...state.original);
        state.container.classList.remove('ds-local-active');
        state.grid.removeAttribute('aria-busy');
        if (state.count) state.count.textContent = state.countText;
        more.hidden = true;
      };
      const render = () => {
        if (!state?.grid.isConnected) return;
        state.container.classList.add('ds-local-active');
        state.grid.replaceChildren(...matches.slice(0, limit));
        state.grid.querySelectorAll('[data-aos]').forEach(element => element.classList.add('aos-init', 'aos-animate'));
        state.grid.removeAttribute('aria-busy');
        status.textContent = self.dataset.results.replace('[count]', matches.length);
        if (state.count) state.count.textContent = status.textContent;
        shown.textContent = self.dataset.shown.replace('[visible]', Math.min(limit, matches.length)).replace('[total]', matches.length);
        more.hidden = matches.length === 0;
        load.hidden = limit >= matches.length;
      };
      const collect = async current => {
        if (current.all) return current.all;
        if (current.pending) return current.pending;
        current.pending = (async () => {
          const pages = new Map([[current.page, current.original.filter(n => n.nodeType === 1 && n.matches('.grid-product[data-product-id]'))]]);
          const queue = Array.from({length: current.pages}, (_, i) => i + 1).filter(p => p !== current.page);
          const worker = async () => {
            while (queue.length) {
              const page = queue.shift();
              const url = new URL(current.url);
              url.hash = '';
              url.searchParams.set('page', page);
              url.searchParams.set('section_id', current.sectionId);
              const response = await fetch(url, {signal: AbortSignal.timeout(25000)});
              if (!response.ok) throw new Error('Collection page unavailable');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const pageGrid = doc.querySelector('#CollectionAjaxContent .grid--uniform');
              if (!pageGrid) throw new Error('Collection grid unavailable');
              pages.set(page, cards(pageGrid).map(card => document.importNode(card, true)));
            }
          };
          await Promise.all(Array.from({length: Math.min(3, queue.length)}, worker));
          const seen = new Set();
          const all = [...pages.entries()].sort((a,b) => a[0]-b[0]).flatMap(([,items]) => items).filter(card => {
            const id = card.dataset.productId;
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
          });
          current.all = all;
          return all;
        })().catch(error => {current.pending = null;throw error;});
        return current.pending;
      };
      const apply = async () => {
        remember();
        const token = ++version;
        limit = 35;
        clear.hidden = !active();
        if (!state || !active()) {
          restore();
          status.textContent = '';
          return;
        }
        const current = state;
        status.textContent = self.dataset.loading;
        current.grid.setAttribute('aria-busy', 'true');
        try {
          const all = await collect(current);
          if (token !== version || current !== state || !active()) return;
          const terms = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
          matches = all.filter(card => {
            const text = normalize([card.querySelector('.grid-product__title')?.textContent || '', card.querySelector('.grid-product__vendor')?.textContent || '', card.dataset.productHandle || ''].join(' '));
            return terms.every(term => text.includes(term)) && (!sale.checked || !!card.querySelector('.grid-product__price--original'));
          });
          render();
        } catch (error) {
          if (token !== version || current !== state) return;
          restore();
          status.textContent = self.dataset.error;
        }
      };
      const bind = () => {
        const container = document.querySelector('#CollectionAjaxContent');
        const grid = container?.querySelector('.grid--uniform');
        if (!grid || grid === state?.grid) return;
        version++;
        const pagination = container.querySelector('.pagination');
        const url = new URL(location.href);
        const page = Number(url.searchParams.get('page') || 1);
        const pageNumbers = [...(pagination?.querySelectorAll('a[href]') || [])].map(a => Number(new URL(a.href).searchParams.get('page') || 1));
        const count = container.querySelector('.collection-filter__item--count');
        state = {container, grid, original:[...grid.childNodes], count, countText:count?.textContent || '', page, pages:Math.max(page, ...pageNumbers), url:url.href, sectionId:container.closest('[data-section-id]').dataset.sectionId};
        container.querySelector('.grid__item--content').prepend(self);
        grid.after(more);
        self.hidden = false;
        if (active()) apply();
      };
      input.addEventListener('input', apply);
      sale.addEventListener('change', apply);
      clear.addEventListener('click', () => {input.value = '';sale.checked = false;apply();});
      load.addEventListener('click', () => {limit += 35;render();});
      const start = () => {
        bind();
        new MutationObserver(bind).observe(document.querySelector('#MainContent'), {childList:true,subtree:true});
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
      else start();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-discovery-curation"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const dataNode = document.getElementById('ms-discovery-curation-data');
    const main = document.getElementById('MainContent');
    if (!dataNode || !main) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    const baselinePath = new URL(data.path, location.origin).pathname;
    if (location.pathname.replace(/\/$/, '') !== baselinePath.replace(/\/$/, '')) return;
    if ([...new URLSearchParams(location.search).keys()].some(key => key.startsWith('filter.') || key === 'q')) return;
    if (!data.unfiltered || !Array.isArray(data.vendors) || !data.vendors.length) return;
    const vendors = new Set(data.vendors.map(value => value.toLowerCase()));
    const counts = new Map(data.counts.filter(entry => Number.isInteger(entry[1])).map(([name,count]) => [name.toLowerCase(),count]));
    const curate = () => {
      main.querySelectorAll('a[href*="filter.p.vendor="]').forEach(card => {
        if (!card.querySelector('img') || card.closest('.grid-product,[data-product-id]')) return;
        let target;
        try { target = new URL(card.href, location.origin); } catch { return; }
        if (target.origin !== location.origin || target.pathname !== baselinePath) return;
        const filters = [...target.searchParams.keys()].filter(key => key.startsWith('filter.'));
        const values = target.searchParams.getAll('filter.p.vendor');
        if (filters.length !== 1 || values.length !== 1 || values[0].includes(',')) return;
        const vendor = values[0].toLowerCase();
        const count = counts.has(vendor) ? counts.get(vendor) : vendors.has(vendor) ? null : 0;
        if (count === null || count >= 3) return;
        const wrapper = card.parentElement;
        if (wrapper.matches('li,article') && wrapper.children.length === 1) wrapper.remove();
        else card.remove();
      });
    };
    curate();
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; curate(); });
    }).observe(main, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-fabric-search"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('ms-fabric-search-template');
  if (!template || document.getElementById('ms-fabric-query')) return;
  const normalize = value => value.toLowerCase().replace(/[_-]+/g, ' ').replace(/grey/g, 'gray').replace(/\s+/g, ' ').trim();
  const readable = value => value.replace(/[_]+/g, ' ').replace(/\s+/g, ' ').trim();
  let gradeSelector = 'select[name="properties[FABRIC]"]';
  const upholsterySelector = 'select[name="properties[UPHOLSTERY]"]';
  let fabricSelector = 'input[type="radio"][name^="properties[Fabric Grade"]';
  const allMaterialsSelector = 'input[type="radio"][name^="properties[Fabric Grade"], input[type="radio"][name^="properties[Leather Grade"]';
  let material = null;

  const host = template.content.firstElementChild.cloneNode(true);
  const query = host.querySelector('input');
  const results = host.querySelector('#ms-fabric-results');
  const status = host.querySelector('[role="status"]');
  const selection = host.querySelector('.ms-fabric-search__selection');
  const clear = host.querySelector('.ms-fabric-search__clear');
  const performanceHint = host.querySelector('[data-query="Performance"]');
  const performanceMap = new Map();
  const colorSelect = host.querySelector('.ms-fabric-search__color');
  const gradeFilter = host.querySelector('.ms-fabric-search__grade-filter');
  const colorMap = new Map();
  const fabricCopy = { ...host.dataset, label: host.querySelector('label').textContent, placeholder: query.placeholder, clear: clear.getAttribute('aria-label'), hints: host.querySelector('[role="group"]').getAttribute('aria-label') };
  const leatherCopy = { ...fabricCopy };
  for (const key of ['label', 'placeholder', 'help', 'browse', 'empty', 'error', 'count', 'clear', 'hints']) leatherCopy[key] = host.dataset['leather' + key[0].toUpperCase() + key.slice(1)];
  const tabs = document.createElement('div');
  tabs.className = 'ms-material-tabs';
  tabs.setAttribute('role', 'tablist');
  tabs.setAttribute('aria-label', host.dataset.method);
  const searchTab = document.createElement('button');
  const browseToggle = document.createElement('button');
  for (const [button, id, label] of [[searchTab, 'ms-material-search-tab', host.dataset.searchTab], [browseToggle, 'ms-material-browse-tab', host.dataset.browseTab]]) {
    button.type = 'button'; button.id = id; button.textContent = label; button.setAttribute('role', 'tab'); tabs.append(button);
  }
  host.id = 'ms-material-search-panel';
  host.setAttribute('role', 'tabpanel');
  host.setAttribute('aria-labelledby', searchTab.id);
  searchTab.setAttribute('aria-controls', host.id);
  let browseExpanded = false;
  const syncBrowse = () => {
    if (!root) return;
    const available = Boolean(root.querySelector(upholsterySelector));
    tabs.hidden = !available;
    host.hidden = !available || browseExpanded;
    root.classList.toggle('ms-fabric-browse-collapsed', !browseExpanded);
    searchTab.setAttribute('aria-selected', String(!browseExpanded));
    browseToggle.setAttribute('aria-selected', String(browseExpanded));
    searchTab.tabIndex = browseExpanded ? -1 : 0;
    browseToggle.tabIndex = browseExpanded ? 0 : -1;
    for (const panel of root.querySelectorAll('.ms-fabric-browse-panel')) {
      panel.inert = !browseExpanded;
      if (!browseExpanded) panel.setAttribute('aria-hidden', 'true'); else panel.removeAttribute('aria-hidden');
    }
  };
  const switchView = browse => { browseExpanded = browse; syncBrowse(); };
  searchTab.addEventListener('click', () => switchView(false));
  browseToggle.addEventListener('click', () => switchView(true));
  tabs.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    switchView(event.key === 'Home' ? false : event.key === 'End' ? true : !browseExpanded);
    (browseExpanded ? browseToggle : searchTab).focus();
  });
  let performanceReady = false;
  let root;
  let busy = false;
  let timer;
  const getEntries = () => {
    const seen = new Set();
    const labels = new Map([...root.querySelectorAll('label[for]')].map(label => [label.htmlFor, label]));
    return [...root.querySelectorAll(allMaterialsSelector)].map(input => {
      const grade = input.name.slice(11, -1).trim();
      const entryMaterial = grade.startsWith('Leather') ? 'Leather' : 'Fabric';
      const label = labels.get(input.id);
      return { id: input.id, inputName: input.name, value: input.value, grade, material: entryMaterial, colors: colorMap.get(entryMaterial + '|' + normalize(input.value)) || [], performance: entryMaterial === 'Fabric' ? performanceMap.get(normalize(input.value)) || '' : '', image: label?.style.backgroundImage || '', name: readable(input.value) };
    }).filter(entry => {
      const key = entry.grade + '|' + normalize(entry.value);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };
  const selectedInput = () => {
    const grade = root.querySelector(gradeSelector)?.value;
    return [...root.querySelectorAll(fabricSelector)].find(input => input.checked && !input.disabled && normalize(input.name.slice(11, -1)) === normalize(grade || ''));
  };
  const updateColors = () => {
    const previous = colorSelect.value;
    while (colorSelect.options.length > 1) colorSelect.remove(1);
    const colors = [...new Set(getEntries().flatMap(entry => entry.colors))].sort();
    for (const color of colors) { const option = document.createElement('option'); option.value = color; option.textContent = color; colorSelect.append(option); }
    colorSelect.value = colors.includes(previous) ? previous : '';
    colorSelect.disabled = !colors.length;
  };
  const updateMaterial = () => {
    const next = root.querySelector(upholsterySelector)?.value || '';

    if (next === material) return;
    material = next;
    gradeSelector = material === 'Leather' ? 'select[name="properties[LEATHER]"]' : 'select[name="properties[FABRIC]"]';
    fabricSelector = material === 'Leather' ? 'input[type="radio"][name^="properties[Leather Grade"]' : 'input[type="radio"][name^="properties[Fabric Grade"]';
    const copy = material === 'Leather' ? leatherCopy : fabricCopy;
    host.dataset.browse = copy.browse;

    if (gradeFilter.options.length === 1) {
      const controls = root.querySelectorAll('select[name="properties[FABRIC]"], select[name="properties[LEATHER]"]');
      for (const control of controls) for (const entry of control.options) {
        if (!entry.value || entry.disabled) continue;
        const option = document.createElement('option'); option.value = normalize(entry.value); option.textContent = entry.textContent; gradeFilter.append(option);
      }
    }
    updateColors();
  };
  const refresh = () => {
    if (!root?.isConnected) return;
    updateMaterial();
    performanceHint.hidden = !performanceReady;
    const gradeControl = root.querySelector(gradeSelector);
    const gradeTitle = gradeControl?.closest('.selector-wrapper')?.querySelector('.bcpo-title');
    if (gradeTitle && gradeTitle.textContent !== host.dataset.browse) gradeTitle.textContent = host.dataset.browse;
    const gradeWrapper = gradeControl?.closest('.selector-wrapper');
    if (gradeWrapper) {
      gradeWrapper.classList.add('ms-fabric-browse');
      const browseStart = root.querySelector(upholsterySelector)?.closest('.selector-wrapper') || gradeWrapper;
      if (host.nextElementSibling !== browseStart) browseStart.before(host);
      if (selection.nextElementSibling !== host) host.before(selection);
      if (tabs.nextElementSibling !== selection) selection.before(tabs);
      const allControls = root.querySelectorAll('select[name="properties[UPHOLSTERY]"], select[name="properties[FABRIC]"], select[name="properties[LEATHER]"], input[type="radio"][name^="properties[Fabric Grade"], input[type="radio"][name^="properties[Leather Grade"]');
      const panels = [...new Set([...allControls].map(input => input.closest('.selector-wrapper')))].filter(Boolean);
      panels.forEach((panel, index) => { panel.classList.add('ms-fabric-browse-panel'); if (!panel.id) panel.id = 'ms-fabric-browse-panel-' + index; });
      browseToggle.setAttribute('aria-controls', panels.map(panel => panel.id).join(' '));
      gradeWrapper.setAttribute('role', 'tabpanel');
      gradeWrapper.setAttribute('aria-labelledby', browseToggle.id);
      syncBrowse();
      if (!gradeWrapper.querySelector('.ms-fabric-browse__help')) {
        const help = document.createElement('p');
        help.id = 'ms-fabric-browse-help-' + material.toLowerCase();
        help.className = 'ms-fabric-browse__help';
        help.textContent = host.dataset.browseHelp;
        gradeWrapper.querySelector('.bcpo-label')?.after(help);
        gradeControl.setAttribute('aria-describedby', [gradeControl.getAttribute('aria-describedby'), help.id].filter(Boolean).join(' '));
      }
    }
    const placeholder = gradeControl?.querySelector('option[value=""]');
    if (placeholder && placeholder.textContent !== host.dataset.chooseGrade) placeholder.textContent = host.dataset.chooseGrade;
    const tokens = normalize(query.value).split(' ').filter(Boolean);
    const selected = selectedInput();
    selection.hidden = !selected;
    const selectedText = selected ? '✓ ' + host.dataset.selected + ' ' + readable(selected.value) + ' · ' + selected.name.slice(11, -1).trim() : '';
    if (selection.textContent !== selectedText) selection.textContent = selectedText;
    const focusedId = results.contains(document.activeElement) ? document.activeElement.dataset.fabricId : null;
    const scrollTop = results.scrollTop;
    const filtering = tokens.length > 0 || Boolean(colorSelect.value) || Boolean(gradeFilter.value);
    clear.hidden = !filtering;
    results.replaceChildren();
    results.hidden = !filtering;
    if (!filtering) { status.textContent = host.dataset.help; return; }
    if (tokens.includes('performance') && !performanceReady) { status.textContent = performanceHint.dataset.unavailable; return; }
    const matches = getEntries().filter(entry => (!gradeFilter.value || normalize(entry.grade) === gradeFilter.value) && (!colorSelect.value || entry.colors.includes(colorSelect.value)) && tokens.every(token => {
      const searchable = normalize(entry.name + ' ' + entry.grade + ' ' + entry.performance + ' ' + entry.colors.join(' '));
      if (/^(i|ii|iii|v|c|d|f|g|h|j)$/.test(token)) return normalize(entry.grade).split(' ').at(-1) === token;
      if (token === 'performance') return Boolean(entry.performance);
      return searchable.includes(token);
    }));
    status.textContent = matches.length ? host.dataset.count.replace('[shown]', Math.min(matches.length, 30)).replace('[total]', matches.length) : host.dataset.empty;
    for (const entry of matches.slice(0, 30)) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ms-fabric-search__result';
      button.dataset.fabricId = entry.id;
      button.setAttribute('aria-pressed', String(selected?.id === entry.id));
      const swatch = document.createElement('span');
      swatch.className = 'ms-fabric-search__swatch';
      swatch.style.backgroundImage = entry.image;
      swatch.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      const name = document.createElement('span');
      name.className = 'ms-fabric-search__name';
      name.textContent = entry.name;
      const grade = document.createElement('span');
      grade.className = 'ms-fabric-search__grade';
      grade.textContent = entry.grade + (entry.performance ? ' · ' + entry.performance : '');
      text.append(name, grade);
      button.append(swatch, text);
      if (selected?.id === entry.id) {
        const check = document.createElement('span');
        check.className = 'ms-fabric-search__check';
        check.textContent = '✓';
        check.setAttribute('aria-hidden', 'true');
        button.append(check);
      }
      button.addEventListener('click', () => selectEntry(entry));
      results.append(button);
    }
    if (focusedId) [...results.querySelectorAll('button')].find(button => button.dataset.fabricId === focusedId)?.focus({ preventScroll: true });
    results.scrollTop = scrollTop;
  };
  const selectEntry = async entry => {
    if (busy) return;
    busy = true;
    const wasExpanded = browseExpanded;
    let applied = false;
    browseExpanded = true;
    syncBrowse();
    try {
      const upholstery = root.querySelector(upholsterySelector);
      if (upholstery.value !== entry.material) {
        upholstery.value = entry.material;
        upholstery.dispatchEvent(new Event('change', { bubbles: true }));
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        updateMaterial();
      }
      const grade = root.querySelector(gradeSelector);
      const option = [...grade.options].find(option => normalize(option.value) === normalize(entry.grade));
      if (!option || option.disabled) throw new Error('Unavailable grade');
      if (grade.value !== option.value) {
        grade.value = option.value;
        grade.dispatchEvent(new Event('change', { bubbles: true }));
      }
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      const input = [...root.querySelectorAll(fabricSelector)].find(input => input.name === entry.inputName && input.value === entry.value && !input.disabled);
      if (!input) throw new Error('Unavailable fabric');
      input.click();
      if (!input.checked) throw new Error('Selection not applied');
      applied = true;
      refresh();
    } catch (error) {
      browseExpanded = true; syncBrowse();
      status.textContent = host.dataset.error;
    } finally { if (applied) { browseExpanded = wasExpanded; syncBrowse(); } busy = false; }
  };
  query.addEventListener('input', refresh);
  colorSelect.addEventListener('change', refresh);
  gradeFilter.addEventListener('change', refresh);
  host.querySelectorAll('[data-query]').forEach(button => button.addEventListener('click', () => { query.value = button.dataset.query; refresh(); }));
  query.addEventListener('keydown', event => {
    if (event.key === 'Enter') event.preventDefault();
    if (event.key === 'ArrowDown') { event.preventDefault(); results.querySelector('button')?.focus(); }
    if (event.key === 'Escape') { query.value = ''; refresh(); }
  });
  results.addEventListener('keydown', event => {
    const buttons = [...results.querySelectorAll('button')];
    const index = buttons.indexOf(document.activeElement);
    if (event.key === 'ArrowDown') { event.preventDefault(); buttons[Math.min(index + 1, buttons.length - 1)]?.focus(); }
    if (event.key === 'ArrowUp') { event.preventDefault(); if (index <= 0) query.focus(); else buttons[index - 1].focus(); }
    if (event.key === 'Escape') { query.value = ''; refresh(); query.focus(); }
  });
  clear.addEventListener('click', () => { query.value = ''; colorSelect.value = ''; gradeFilter.value = ''; refresh(); query.focus(); });
  const mount = () => {
    const grade = document.querySelector(gradeSelector);
    if (!grade) return false;
    root = grade.closest('.bcpo');
    const wrapper = grade.closest('.selector-wrapper');
    if (!root || !wrapper || !root.querySelector(fabricSelector)) return false;
    wrapper.before(host);
    root.addEventListener('invalid', event => {
      if (event.target.closest('.ms-fabric-browse-panel')) { browseExpanded = true; syncBrowse(); }
    }, true);
    root.addEventListener('change', event => { if (!busy && !host.contains(event.target)) refresh(); });
    refresh();
    (async () => {
      try {
        const get = async page => {
          const response = await fetch('/collections/american-leather-swatches?view=ms-material-index&sort_by=title-ascending&page=' + page, { signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error('Color index unavailable');
          const data = await response.json();
          if (!Array.isArray(data.products) || data.page !== page || !Number.isInteger(data.pages) || data.pages < 1 || data.pages > 10) throw new Error('Invalid color index');
          return data;
        };
        const first = await get(1);
        const products = [...first.products];
        for (let page = 2; page <= first.pages; page++) {
          const next = await get(page);
          if (next.total !== first.total) throw new Error('Color index changed');
          products.push(...next.products);
        }
        if (products.length !== first.total) throw new Error('Incomplete color index');
        for (const product of products) {
          const match = product.title.match(/^(Leather\s+)?Grade\s+[A-Z]+\s*:\s*(.+)$/i);
          if (!match) continue;
          const name = (match[1] ? 'Leather' : 'Fabric') + '|' + normalize(match[2]);
          const colors = (product.tags || []).filter(tag => /^Color Family:/i.test(tag)).map(tag => tag.replace(/^Color Family:\s*/i, '').trim()).filter(Boolean);
          if (colors.length) colorMap.set(name, colors);
        }

        updateColors();
        if (!busy) refresh();
      } catch { colorSelect.title = colorSelect.dataset.unavailable; }
    })();
    fetch('/pages/fabric-leather-finish-samples', { signal: AbortSignal.timeout(15000) })
      .then(response => { if (!response.ok) throw new Error('Material library unavailable'); return response.text(); })
      .then(html => {
        const data = new DOMParser().parseFromString(html, 'text/html').querySelector('ms-material-library [data-performance]');
        if (!data) throw new Error('Performance index unavailable');
        const entries = Object.entries(JSON.parse(data.textContent));
        if (!entries.length || entries.some(([name, technology]) => !name || typeof technology !== 'string')) throw new Error('Invalid performance index');
        entries.forEach(([name, technology]) => performanceMap.set(normalize(name), technology));
        performanceReady = true;
        performanceHint.disabled = false;
        if (!busy) refresh();
      }).catch(() => { performanceHint.hidden = true; if (!busy) refresh(); });
    const observer = new MutationObserver(mutations => {
      if (!mutations.some(mutation => ![host, selection, tabs].some(owned => owned.contains(mutation.target)))) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        const current = root.querySelector(gradeSelector)?.closest('.selector-wrapper');
        if (current && !host.isConnected) current.before(host);
        if (!busy) refresh();
      }, 80);
    });
    observer.observe(root, { childList: true, subtree: true });
    return true;
  };
  if (!mount()) {
    const observer = new MutationObserver(() => { if (mount()) observer.disconnect(); });
    observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 30000);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-lighting-collection-shell"] && !Shopify.designMode) return;
  try {
    function initializeLightingShell(scope){scope.querySelectorAll('.ms-lighting-shell__styles').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('.ms-lighting-shell__slider'),prev=root.querySelector('[data-lighting-shell-prev]'),next=root.querySelector('[data-lighting-shell-next]');const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};const move=direction=>{const card=track.querySelector('a');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||20;track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});if('ResizeObserver' in window)new ResizeObserver(update).observe(track);update();});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initializeLightingShell(document));else initializeLightingShell(document);
document.addEventListener('shopify:section:load',event=>initializeLightingShell(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-newest-browse"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-newest-browse')) {
  customElements.define('ms-newest-browse', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('details');
      this.media = matchMedia('(min-width:769px)');
      this.resizePanel = () => { this.panel.open = this.media.matches; };
      this.resizePanel();
      this.media.addEventListener('change', this.resizePanel);
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.resizePanel);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["river-complete-collection"] && !Shopify.designMode) return;
  try {
    if (!window.riverSetBuilderReady) {
  window.riverSetBuilderReady = true
  const nativeFetch = window.fetch ? window.fetch.bind(window) : null
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'
  let awaitingMain = null

  const money = cents => {
    const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100)
  }

  const controlsAreValid = productArea => {
    const requiredControls = Array.from(productArea.querySelectorAll('[required]')).filter(control => {
      return !control.disabled && control.offsetParent !== null && !control.closest('.river-set')
    })

    return requiredControls.every(control => {
      if (control.type === 'radio') {
        return Array.from(productArea.querySelectorAll(`input[type="radio"][name="${CSS.escape(control.name)}"]`)).some(input => input.checked)
      }
      if (control.type === 'checkbox') return control.checked
      return Boolean(control.value)
    })
  }

  const matchingPropertyPattern = /(finish|wood|fabric|upholstery|leather|color|colour|stain|metal|frame)/i
  // MS 2026-10-08: lighting attributes are not finishes (e.g. "Color Temperature" matched "color").
  const nonFinishPattern = /(temperature|\bcct\b|kelvin|glass|lamping|bulb|lumen|dimm)/i
  const isFinishName = name => matchingPropertyPattern.test(String(name || '')) && !nonFinishPattern.test(String(name || ''))

  const readJson = (value, fallback = []) => {
    try {
      return JSON.parse(value)
    } catch (error) {
      return fallback
    }
  }

  const getMatchingProperties = productArea => {
    const properties = {}
    Array.from(productArea.querySelectorAll('[name^="properties["]')).forEach(control => {
      if (control.disabled || control.closest('.river-set')) return
      const match = control.name.match(/^properties\[(.+)\]$/)
      if (!match || !isFinishName(match[1])) return
      if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return
      if (!control.value) return
      properties[match[1].trim()] = control.value
    })
    return properties
  }

  // MS 2026-10-08: read the option values the shopper actually sees selected (BCPO controls), falling back to the
  // form's variant id. Avoids the Rio (hero-image variant) / BCPO load race leaving set pieces in the wrong finish.
  const selectedMainOptions = (productArea, mainNames, idVariant, variants) => {
    if (!mainNames.length) return idVariant
    const options = mainNames.map((name, index) => {
      const group = productArea.querySelector(`#bcpo-select-option-${index}`) || document.getElementById(`bcpo-select-option-${index}`)
      let picked = null
      if (group) {
        if (group.tagName === 'SELECT' && group.value) picked = group.value
        const checked = group.tagName !== 'SELECT' && group.querySelector && group.querySelector('input[type="radio"]:checked')
        if (checked && checked.value) picked = checked.value
      }
      // Only trust a control value that is a real value of this option; otherwise use the form's variant.
      if (picked && Array.isArray(variants) && variants.some(variant => variant.options && variant.options[index] === picked)) return picked
      return idVariant && idVariant.options ? idVariant.options[index] : null
    })
    if (options.some(value => value == null)) return idVariant
    return Object.assign({}, idVariant || {}, { options })
  }

  const syncSignatures = new WeakMap()
  const finishSignature = (builder, productArea) => {
    const variantId = productArea.querySelector('form.product-single__form [name="id"]')?.value
    const variants = readJson(builder.querySelector('[data-river-main-variants]')?.textContent)
    const mainVariant = selectedMainOptions(productArea, readJson(builder.dataset.mainOptionNames), { options: [] }, variants)
    return JSON.stringify([variantId, mainVariant && mainVariant.options, getMatchingProperties(productArea)])
  }
  // MS 2026-10-08: "Matching finish" shows the set piece's own selected finish, and says so when the piece
  // isn't made in the main product's finish (instead of claiming a match it can't deliver).
  const refreshItemLabels = builder => {
    const wanted = (builder.dataset.msMainFinishes || '').split('\u0001').filter(Boolean)
    builder.querySelectorAll('[data-river-set-item]').forEach(item => {
      if (item.dataset.copyProperties === 'false') return
      const select = item.querySelector('[data-river-set-variant]')
      const match = item.querySelector('[data-river-set-match]')
      const value = match && match.querySelector('[data-river-set-match-value]')
      if (!select || !match || !value) return
      const names = readJson(select.dataset.optionNames)
      const values = readJson(select.selectedOptions[0]?.dataset.options)
      let own = names.map((name, index) => isFinishName(name) ? values[index] : null).filter(Boolean).map(String)
      if (!own.length) own = values.filter(Boolean).map(String)
      if (!own.length || !wanted.length) return
      const lower = text => String(text).trim().toLowerCase()
      const covered = finish => own.some(ownValue => lower(ownValue).includes(lower(finish)))
      if (wanted.some(covered)) {
        if (!names.some(isFinishName)) return
        match.hidden = false
        value.textContent = own.join(' · ')
        return
      }
      match.hidden = false
      const wantedText = wanted.join(' · ')
      value.textContent = `${own.join(' · ')} (${wantedText.length > 28 ? 'no exact match' : `no ${wantedText} option`} – check finish)`
    })
  }

  const syncIfChanged = (builder, productArea, force) => {
    const signature = finishSignature(builder, productArea)
    if (!force && syncSignatures.get(builder) === signature) return
    syncSignatures.set(builder, signature)
    syncVariantFinishes(builder, productArea)
  }
  const syncTimers = new WeakMap()
  const scheduleSync = (productArea, force) => {
    const builder = productArea && productArea.querySelector('[data-river-set-builder]')
    if (!builder) return
    clearTimeout(syncTimers.get(builder))
    syncTimers.set(builder, setTimeout(() => syncIfChanged(builder, productArea, force), 40))
  }

  const syncVariantFinishes = (builder, productArea) => {
    const woodCodes = new Set(["05", "07", "10", "11", "14", "16", "21", "22", "23", "24", "29", "30", "32", "34", "36", "39", "49", "69", "79", "500", "504", "511", "514", "519", "523", "532", "549", "404", "405", "407", "410", "411", "423", "424", "430", "432", "434", "435", "436", "439", "469", "704", "705", "707", "710", "711", "723", "724", "730", "734", "735", "739"])
    const normalizeFinish = (value, name) => {
      const label = String(value).trim().toLowerCase()
      if (builder.dataset.vendor !== 'huppe' || !/(wood|finish|stain)/i.test(name)) return label
      const codes = (label.match(/\b\d{1,3}\b/g) || []).map(code => code.padStart(2, '0')).filter(code => woodCodes.has(code))
      return codes.length === 1 ? `huppe-wood:${codes[0]}` : label
    }
    const variantData = builder.querySelector('[data-river-main-variants]')
    const variantId = productArea.querySelector('form.product-single__form [name="id"]')?.value
    const mainVariants = readJson(variantData?.textContent)
    const idVariant = mainVariants.find(variant => String(variant.id) === String(variantId))
    const mainNames = readJson(builder.dataset.mainOptionNames)
    const mainVariant = selectedMainOptions(productArea, mainNames, idVariant, mainVariants)
    const matchingLabels = Object.values(getMatchingProperties(productArea))

    if (mainVariant && mainNames.length) {
      mainNames.forEach((name, index) => {
        if (isFinishName(name) && mainVariant.options[index]) matchingLabels.push(String(mainVariant.options[index]).trim())
      })
    }

    const uniqueLabels = matchingLabels.filter((value, index, values) => {
      return values.findIndex(item => item.toLowerCase() === value.toLowerCase()) === index
    })
    builder.dataset.msMainFinishes = mainVariant && mainNames.length
      ? mainNames.map((name, index) => isFinishName(name) && mainVariant.options && mainVariant.options[index] ? String(mainVariant.options[index]) : null).filter(Boolean).join('\u0001')
      : ''
    builder.querySelectorAll('[data-river-set-match]').forEach(match => {
      const value = match.querySelector('[data-river-set-match-value]')
      match.hidden = match.closest('[data-river-set-item]')?.dataset.copyProperties === 'false' || !uniqueLabels.length
      if (value) value.textContent = uniqueLabels.join(' · ')
    })

    const mainFinishes = new Map()
    Object.entries(getMatchingProperties(productArea)).forEach(([name, value]) => {
      mainFinishes.set(name.trim().toLowerCase(), normalizeFinish(value, name))
    })
    mainNames.forEach((name, index) => {
      if (mainVariant && isFinishName(name) && mainVariant.options[index]) {
        mainFinishes.set(name.trim().toLowerCase(), normalizeFinish(mainVariant.options[index], name))
      }
    })
    if (!mainFinishes.size) return

    builder.querySelectorAll('[data-river-set-variant]').forEach(select => {
      const optionNames = readJson(select.dataset.optionNames)
      const desired = []
      optionNames.forEach((name, index) => {
        if (!isFinishName(name)) return
        const exact = mainFinishes.get(name.trim().toLowerCase())
        const value = exact || (mainFinishes.size === 1 ? Array.from(mainFinishes.values())[0] : null)
        if (value) desired.push([index, value])
      })
      if (!desired.length) {
        const finishValues = Array.from(mainFinishes.values())
        optionNames.forEach((name, index) => {
          const hasMatchingValue = Array.from(select.options).some(option => {
            const values = readJson(option.dataset.options).map((value, index) => normalizeFinish(value, optionNames[index]))
            return finishValues.includes(values[index])
          })
          if (hasMatchingValue) {
            const selectedValue = readJson(select.selectedOptions[0]?.dataset.options)[index]
            const matchingValue = finishValues.find(value => {
              return Array.from(select.options).some(option => {
                const values = readJson(option.dataset.options).map((value, index) => normalizeFinish(value, optionNames[index]))
                return values[index] === value
              })
            })
            if (matchingValue && normalizeFinish(selectedValue, name) !== matchingValue) desired.push([index, matchingValue])
          }
        })
      }
      if (!desired.length) return

      const currentValues = readJson(select.selectedOptions[0]?.dataset.options).map((value, index) => normalizeFinish(value, optionNames[index]))
      const matches = Array.from(select.options).filter(option => {
        const values = readJson(option.dataset.options).map((value, index) => normalizeFinish(value, optionNames[index]))
        return desired.every(([index, value]) => values[index] === value)
      })
      const match = matches.find(option => {
        const values = readJson(option.dataset.options).map((value, index) => normalizeFinish(value, optionNames[index]))
        return optionNames.every((name, index) => desired.some(([matchedIndex]) => matchedIndex === index) || values[index] === currentValues[index])
      }) || matches[0]
      if (!match) return
      const matchingNote = select.closest('[data-river-set-item]').querySelector('[data-river-set-match]')
      if (matchingNote && select.closest('[data-river-set-item]').dataset.copyProperties === 'false') {
        matchingNote.hidden = false
        matchingNote.querySelector('[data-river-set-match-value]').textContent = desired.map(([index]) => readJson(match.dataset.options)[index]).join(' · ')
      }
      if (select.value === match.value) return

      select.value = match.value
      const item = select.closest('[data-river-set-item]')
      const checkbox = item.querySelector('[data-river-set-checkbox]')
      const price = item.querySelector('[data-river-set-price]')
      item.dataset.price = match.dataset.price
      checkbox.value = match.value
      if (price) price.textContent = money(Number(match.dataset.price))
    })
    refreshItemLabels(builder)
    update(builder)
  }

  const setButtonState = (builder, loading) => {
    const productArea = builder.closest('[data-product-blocks]') || document
    const addButton = productArea.querySelector('[data-add-to-cart]')
    const addLabel = productArea.querySelector('[data-add-to-cart-text]')
    if (addButton) addButton.disabled = loading
    if (addLabel && loading) addLabel.textContent = builder.dataset.addingLabel
    return { addButton, addLabel }
  }

  const restoreBuilder = builder => {
    const selected = builder.querySelectorAll('[data-river-set-checkbox]:checked').length
    const { addButton, addLabel } = setButtonState(builder, false)
    if (addButton) addButton.disabled = false
    if (addLabel) addLabel.textContent = selected ? builder.dataset.bundleLabel : addLabel.dataset.defaultText
  }

  const update = builder => {
    const selected = Array.from(builder.querySelectorAll('[data-river-set-checkbox]:checked'))
    const total = selected.reduce((sum, input) => {
      const item = input.closest('[data-river-set-item]')
      const quantity = Math.max(1, Math.min(99, Number.parseInt(item.querySelector('[data-river-set-quantity]')?.value || '1', 10) || 1))
      return sum + Number(item.dataset.price || 0) * quantity
    }, 0)
    const totalElement = builder.querySelector('[data-river-set-total]')
    const productArea = builder.closest('[data-product-blocks]') || document
    const addLabel = productArea.querySelector('[data-add-to-cart-text]')
    if (totalElement) totalElement.textContent = money(total)
    if (addLabel) addLabel.textContent = selected.length ? builder.dataset.bundleLabel : addLabel.dataset.defaultText
  }

  const rollback = async bundle => {
    if (!nativeFetch || !bundle.addedItems) return
    await Promise.all(bundle.addedItems.map(item => {
      const quantity = bundle.previousQuantities.get(item.key) || 0
      return nativeFetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity })
      })
    }))
  }

  const mainAdded = () => {
    if (!awaitingMain) return
    awaitingMain = null
    window.location.assign(root + 'cart')
  }

  const huppeItemStates = new WeakMap()
  const inlineLabels = builder => readJson(builder.dataset.huppeLabels, {})
  const chosenFieldValues = field => field.multi
    ? Array.from(field.element.querySelectorAll('input:checked')).map(input => input.value)
    : [field.input.value].filter(Boolean)

  const refreshHuppeItem = item => {
    const state = huppeItemStates.get(item)
    if (!state || !state.data) return
    const names = state.data.options
    const native = state.native.map(field => field.input.value)
    const variant = state.data.variants.find(v => v.available && names.every((name, i) => v.options[i] === native[i]))
    state.variant = variant
    const values = new Map(state.native.map((field, i) => [state.data.config.shopify_options?.[i]?.unique, [field.input.value]]))
    for (let pass = 0; pass <= state.fields.length; pass++) {
      let changed = false
      state.fields.forEach(field => {
        const parent = field.option.conditional_option
        const visible = !parent || (values.get(parent) || []).includes(field.option.conditional_value)
        if (field.element.hidden === visible) changed = true
        field.element.hidden = !visible
        values.set(field.option.unique, visible ? chosenFieldValues(field) : [])
        field.element.querySelectorAll('select,input').forEach(input => { input.disabled = !visible })
      })
      if (!changed) break
    }
    let extra = 0
    const properties = {}
    state.fields.filter(field => !field.element.hidden).forEach(field => {
      const selected = chosenFieldValues(field)
      const options = field.option.values.filter(v => selected.includes(String(v.key)))
      const price = options.reduce((sum, v) => sum + Number(v.price || 0), 0)
      extra += price
      if (selected.length) properties[field.option.title] = selected.join(', ') + (price ? ' | $' + price.toFixed(2) : '')
      if (field.preview) {
        const url = options[0]?.value
        field.preview.hidden = !url
        if (url) { field.preview.src = url; field.preview.alt = selected[0] }
      }
    })
    state.properties = properties
    const rate = Number(window.Shopify?.currency?.rate || 1)
    const price = variant ? variant.price + Math.round(extra * 100 * rate) : 0
    state.valid = !!variant
    item.dataset.price = String(price)
    const checkbox = item.querySelector('[data-river-set-checkbox]')
    if (variant) checkbox.value = variant.id
    item.querySelector('[data-river-set-price]').textContent = variant ? money(price) : state.labels.unavailable
    state.notice.textContent = variant ? '' : state.labels.unavailable
    state.native.forEach(field => field.input.setAttribute('aria-invalid', variant ? 'false' : 'true'))
    if (variant?.featured_image?.src) {
      const image = item.querySelector('.river-set__image img')
      image.removeAttribute('srcset')
      image.src = variant.featured_image.src
    }
    update(item.closest('[data-river-set-builder]'))
  }

  const loadHuppeItem = async item => {
    let state = huppeItemStates.get(item)
    if (state?.promise) return state.promise
    const builder = item.closest('[data-river-set-builder]')
    const labels = inlineLabels(builder)
    const host = item.querySelector('[data-huppe-set-options]')
    state = { labels, host, native: [], fields: [] }
    huppeItemStates.set(item, state)
    host.hidden = false
    host.textContent = labels.loading
    state.promise = (async () => {
      try {
        const url = new URL(item.dataset.huppeSetUrl, location.origin)
        url.searchParams.set('view', 'huppe-set-options')
        const preview = new URL(location.href).searchParams.get('preview_theme_id') || window.Shopify?.theme?.id
        if (preview) url.searchParams.set('preview_theme_id', preview)
        const response = await nativeFetch(url.pathname + url.search, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        if (!response.ok) throw new Error(labels.loadError)
        const data = await response.json()
        if (!Array.isArray(data.variants) || !data.variants.length || data.variants.length >= 250) throw new Error(labels.loadError)
        data.config = data.config || { shopify_options: [], virtual_options: [] }
        const controls = (data.config.virtual_options || []).filter(o => !['instructions', 'html'].includes(o.type))
        if (controls.some(o => !['images','dropdown','default','radio','checkboxes'].includes(o.type) || !Array.isArray(o.values) || o.values.some(v => !Number.isFinite(Number(v.price || 0))))) throw new Error(labels.fullPage)
        state.data = data
        host.textContent = ''
        const first = data.variants.find(v => String(v.id) === item.querySelector('[data-river-set-checkbox]').value) || data.variants.find(v => v.available)
        const makeField = (title, options, id, initial, multi, image) => {
          const element = document.createElement('div')
          element.className = 'river-set__option'
          const label = document.createElement('label')
          label.textContent = title
          const controlId = 'HuppeSet-' + data.id + '-' + id + '-' + builder.getAttribute('aria-labelledby')
          label.htmlFor = controlId
          element.append(label)
          let input, preview
          if (multi) {
            element.setAttribute('role', 'group')
            element.setAttribute('aria-label', title)
            options.forEach((v, i) => {
              const row = document.createElement('label')
              row.className = 'river-set__option-check'
              const checkbox = document.createElement('input')
              checkbox.type = 'checkbox'; checkbox.value = String(v.key)
              checkbox.id = controlId + '-' + i
              checkbox.checked = initial === String(v.key)
              row.append(checkbox, document.createTextNode(String(v.key) + (Number(v.price) ? ' (+' + money(Number(v.price) * 100 * Number(window.Shopify?.currency?.rate || 1)) + ')' : '')))
              element.append(row)
            })
          } else {
            input = document.createElement('select'); input.id = controlId
            input.add(new Option(labels.choose, ''))
            options.forEach(v => input.add(new Option(String(v.key) + (Number(v.price) ? ' (+' + money(Number(v.price) * 100 * Number(window.Shopify?.currency?.rate || 1)) + ')' : ''), String(v.key))))
            input.value = initial || ''
            const row = document.createElement('div'); row.className = 'river-set__option-control'
            if (image) { preview = document.createElement('img'); preview.width = 40; preview.height = 40; preview.hidden = true; row.append(preview) }
            row.append(input); element.append(row)
          }
          host.append(element)
          return { element, input, preview, multi }
        }
        data.options.forEach((name, i) => {
          const choices = [...new Set(data.variants.filter(v => v.available).map(v => v.options[i]))]
          const field = makeField(name, choices.map(key => ({ key })), 'native-' + i, first.options[i], false, false)
          if (data.options.length === 1 && choices.length === 1 && choices[0] === 'Default Title') field.element.hidden = true
          state.native.push(field)
        })
        controls.forEach((option, i) => {
          const field = makeField(option.title, option.values, 'custom-' + i, option.preselect_value, option.type === 'checkboxes', option.type === 'images')
          field.option = option
          state.fields.push(field)
        })
        state.notice = document.createElement('p'); state.notice.className = 'river-set__option-error'; state.notice.setAttribute('role','status'); host.append(state.notice)
        host.addEventListener('change', () => refreshHuppeItem(item))
        refreshHuppeItem(item)
        return state
      } catch (error) {
        state.error = error
        host.textContent = error.message || labels.loadError
        throw error
      }
    })()
    return state.promise
  }

  const revealHuppeItem = item => {
    const checkbox = item.querySelector('[data-river-set-checkbox]')
    const host = item.querySelector('[data-huppe-set-options]')
    host.hidden = !checkbox.checked
    if (checkbox.checked) loadHuppeItem(item).then(() => { host.hidden = !checkbox.checked }).catch(() => {})
  }

  const validateHuppeItems = async selected => {
    for (const checkbox of selected) {
      const item = checkbox.closest('[data-river-set-item]')
      if (!item.hasAttribute('data-huppe-set-url')) continue
      const state = await loadHuppeItem(item)
      state.host.hidden = false
      refreshHuppeItem(item)
      if (!state.valid) throw new Error(state.labels.unavailable)
      for (const field of state.fields) {
        const required = field.option.required === 'on' || field.option.required === true
        if (!field.element.hidden && required && !chosenFieldValues(field).length) {
          state.notice.textContent = state.labels.required.replace('[option]', field.option.title)
          field.element.querySelector('select,input')?.focus()
          throw new Error(state.notice.textContent)
        }
      }
    }
  }

  const prepareSetAdd = async (form, builder, productArea) => {
    syncVariantFinishes(builder, productArea)
    const selected = Array.from(builder.querySelectorAll('[data-river-set-checkbox]:checked'))
    const matchingProperties = getMatchingProperties(productArea)
    const status = builder.querySelector('[data-river-set-status]')
    if (status) status.textContent = ''
    setButtonState(builder, true)

    try {
      await validateHuppeItems(selected)
      const cartResponse = await nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      if (!cartResponse.ok) throw new Error('Cart could not be read')
      const cart = await cartResponse.json()
      const previousQuantities = new Map(cart.items.map(item => [item.key, item.quantity]))
      const extrasResponse = await nativeFetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: selected.map(input => ({
            id: Number(input.value),
            quantity: Math.max(1, Math.min(99, Number.parseInt(input.closest('[data-river-set-item]').querySelector('[data-river-set-quantity]')?.value || '1', 10) || 1)),
            ...(huppeItemStates.get(input.closest('[data-river-set-item]'))?.properties ? { properties: huppeItemStates.get(input.closest('[data-river-set-item]')).properties } : input.closest('[data-river-set-item]').dataset.copyProperties !== 'false' && Object.keys(matchingProperties).length ? { properties: matchingProperties } : {})
          }))
        })
      })
      if (!extrasResponse.ok) throw new Error('Set items could not be added')
      const extras = await extrasResponse.json()
      const addedItems = Array.isArray(extras.items) ? extras.items : [extras]
      awaitingMain = { builder, form, previousQuantities, addedItems }
      form.dataset.riverSetPrepared = 'true'
      let returnInput = form.querySelector('input[name="return_to"]')
      if (!returnInput) {
        returnInput = document.createElement('input')
        returnInput.type = 'hidden'
        returnInput.name = 'return_to'
        form.appendChild(returnInput)
      }
      returnInput.value = root + 'cart'
      const addButton = productArea.querySelector('[data-add-to-cart]')
      if (addButton) {
        addButton.disabled = false
        addButton.dataset.riverSetReplay = 'true'
        addButton.click()
      } else {
        form.requestSubmit()
      }

      const bundle = awaitingMain
      setTimeout(async () => {
        if (awaitingMain !== bundle || document.visibilityState !== 'visible') return
        awaitingMain = null
        await rollback(bundle)
        restoreBuilder(builder)
        if (status) status.textContent = builder.dataset.errorLabel
      }, 25000)
    } catch (error) {
      restoreBuilder(builder)
      if (status) status.textContent = error.message || builder.dataset.errorLabel
    }
  }

  document.addEventListener('change', event => {
    const builder = event.target.closest('[data-river-set-builder]')
    if (!builder) {
      const productArea = event.target.closest('[data-product-blocks]')
      const productBuilder = productArea && productArea.querySelector('[data-river-set-builder]')
      if (productBuilder) setTimeout(() => syncIfChanged(productBuilder, productArea, true), 0)
      return
    }
    const huppeItem = event.target.closest('[data-huppe-set-url]')
    if (huppeItem && event.target.matches('[data-river-set-checkbox], [data-river-set-quantity]')) {
      if (event.target.matches('[data-river-set-quantity]')) huppeItem.querySelector('[data-river-set-checkbox]').checked = true
      revealHuppeItem(huppeItem)
    }
    if (event.target.matches('[data-river-set-variant]')) {
      const item = event.target.closest('[data-river-set-item]')
      const option = event.target.selectedOptions[0]
      const checkbox = item.querySelector('[data-river-set-checkbox]')
      const price = item.querySelector('[data-river-set-price]')
      item.dataset.price = option.dataset.price
      checkbox.value = option.value
      if (price) price.textContent = money(Number(option.dataset.price))
      refreshItemLabels(builder)
    }
    if (event.target.matches('[data-river-set-quantity]')) {
      const quantity = Math.max(1, Math.min(99, Number.parseInt(event.target.value || '1', 10) || 1))
      event.target.value = quantity
      event.target.closest('[data-river-set-item]').querySelector('[data-river-set-checkbox]').checked = true
    }
    update(builder)
  })

  document.querySelectorAll('[data-river-set-builder]').forEach(builder => {
    const productArea = builder.closest('[data-product-blocks]')
    if (productArea) syncIfChanged(builder, productArea, true)
  })

  // MS 2026-10-08: BCPO fires a non-bubbling change on [name=id] when it restores the default after Rio, so also
  // listen in the capture phase, re-check after BCPO initialises / window load, and watch briefly during start-up.
  document.addEventListener('change', event => {
    const target = event.target
    if (!target || !target.closest || target.closest('[data-river-set-builder]')) return
    if (!target.matches('[name="id"], [name="vopo-id"], #bcpo-select, #bcpo select, #bcpo input')) return
    scheduleSync(target.closest('[data-product-blocks]') || document.querySelector('[data-river-set-builder]')?.closest('[data-product-blocks]'))
  }, true)
  const recheckAll = () => document.querySelectorAll('[data-river-set-builder]').forEach(builder => {
    const productArea = builder.closest('[data-product-blocks]')
    if (productArea) syncIfChanged(builder, productArea, false)
  })
  window.addEventListener('load', () => setTimeout(recheckAll, 0))
  const bcpoRoot = document.getElementById('bcpo')
  if (bcpoRoot && window.MutationObserver) {
    const observer = new MutationObserver(() => {
      if (bcpoRoot.classList.contains('ms-bcpo-swatches-ready')) { recheckAll(); observer.disconnect() }
    })
    observer.observe(bcpoRoot, { attributes: true, attributeFilter: ['class'] })
  }
  ;[300, 800, 1500, 2500, 4000, 6000, 9000, 13000].forEach(delay => setTimeout(recheckAll, delay))

  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('[data-river-set-quantity-change]')
    if (quantityButton) {
      event.preventDefault()
      const item = quantityButton.closest('[data-river-set-item]')
      const input = item.querySelector('[data-river-set-quantity]')
      const change = Number.parseInt(quantityButton.dataset.riverSetQuantityChange, 10)
      const quantity = Math.max(1, Math.min(99, (Number.parseInt(input.value || '1', 10) || 1) + change))
      input.value = quantity
      item.querySelector('[data-river-set-checkbox]').checked = true
      if (item.hasAttribute('data-huppe-set-url')) revealHuppeItem(item)
      update(quantityButton.closest('[data-river-set-builder]'))
      return
    }

    const addButton = event.target.closest('[data-add-to-cart]')
    if (!addButton) return
    if (addButton.dataset.riverSetReplay === 'true') {
      delete addButton.dataset.riverSetReplay
      return
    }

    const productArea = addButton.closest('[data-product-blocks]')
    const form = productArea && productArea.querySelector('form.product-single__form')
    const builder = productArea && productArea.querySelector('[data-river-set-builder]')
    if (!form || !builder || !nativeFetch) return
    const selected = builder.querySelectorAll('[data-river-set-checkbox]:checked')
    if (!selected.length || !controlsAreValid(productArea)) return

    event.preventDefault()
    event.stopImmediatePropagation()
    prepareSetAdd(form, builder, productArea)
  }, true)

  document.addEventListener('submit', async event => {
    const form = event.target.closest('form.product-single__form')
    if (!form) return
    const productArea = form.closest('[data-product-blocks]')
    const builder = productArea && productArea.querySelector('[data-river-set-builder]')
    if (!builder) return

    if (form.dataset.riverSetPrepared === 'true') {
      delete form.dataset.riverSetPrepared
      return
    }

    const selected = Array.from(builder.querySelectorAll('[data-river-set-checkbox]:checked'))
    if (!selected.length || !nativeFetch || !controlsAreValid(productArea)) return

    event.preventDefault()
    event.stopImmediatePropagation()
    prepareSetAdd(form, builder, productArea)
  }, true)

  if (nativeFetch) {
    window.fetch = async (...args) => {
      const target = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url
      const response = await nativeFetch(...args)
      if (awaitingMain && target && target.includes('/cart/add') && response.ok) setTimeout(mainAdded, 0)
      return response
    }
  }

  if (window.XMLHttpRequest) {
    const open = window.XMLHttpRequest.prototype.open
    const send = window.XMLHttpRequest.prototype.send
    window.XMLHttpRequest.prototype.open = function(method, url, ...args) {
      this.riverSetUrl = url
      return open.call(this, method, url, ...args)
    }
    window.XMLHttpRequest.prototype.send = function(...args) {
      if (this.riverSetUrl && String(this.riverSetUrl).includes('/cart/add')) {
        this.addEventListener('load', () => {
          if (awaitingMain && this.status >= 200 && this.status < 300) mainAdded()
        }, { once: true })
      }
      return send.apply(this, args)
    }
  }
}
  } catch(e) { console.error(e); }
})();

})();
